export var AccessibilityEvidenceKind;
(function (AccessibilityEvidenceKind) {
    AccessibilityEvidenceKind["ManualReview"] = "MANUAL_REVIEW";
    AccessibilityEvidenceKind["PdfRule"] = "PDF_RULE";
    AccessibilityEvidenceKind["WebDom"] = "WEB_DOM";
})(AccessibilityEvidenceKind || (AccessibilityEvidenceKind = {}));
export var AccessibilityPageClassificationStatus;
(function (AccessibilityPageClassificationStatus) {
    AccessibilityPageClassificationStatus["Candidate"] = "CANDIDATE";
    AccessibilityPageClassificationStatus["Confirmed"] = "CONFIRMED";
})(AccessibilityPageClassificationStatus || (AccessibilityPageClassificationStatus = {}));
export var AccessibilityObservationOrderByInput;
(function (AccessibilityObservationOrderByInput) {
    AccessibilityObservationOrderByInput["ActorAsc"] = "actor_ASC";
    AccessibilityObservationOrderByInput["ActorDesc"] = "actor_DESC";
    AccessibilityObservationOrderByInput["BaselineIdAsc"] = "baselineId_ASC";
    AccessibilityObservationOrderByInput["BaselineIdDesc"] = "baselineId_DESC";
    AccessibilityObservationOrderByInput["BaselineVersionAsc"] = "baselineVersion_ASC";
    AccessibilityObservationOrderByInput["BaselineVersionDesc"] = "baselineVersion_DESC";
    AccessibilityObservationOrderByInput["ClassificationAsc"] = "classification_ASC";
    AccessibilityObservationOrderByInput["ClassificationDesc"] = "classification_DESC";
    AccessibilityObservationOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityObservationOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityObservationOrderByInput["CriterionIdAsc"] = "criterionId_ASC";
    AccessibilityObservationOrderByInput["CriterionIdDesc"] = "criterionId_DESC";
    AccessibilityObservationOrderByInput["EvidenceAsc"] = "evidence_ASC";
    AccessibilityObservationOrderByInput["EvidenceDesc"] = "evidence_DESC";
    AccessibilityObservationOrderByInput["EvidenceKindAsc"] = "evidenceKind_ASC";
    AccessibilityObservationOrderByInput["EvidenceKindDesc"] = "evidenceKind_DESC";
    AccessibilityObservationOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityObservationOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityObservationOrderByInput["ObservationKeyAsc"] = "observationKey_ASC";
    AccessibilityObservationOrderByInput["ObservationKeyDesc"] = "observationKey_DESC";
    AccessibilityObservationOrderByInput["ObservedAtAsc"] = "observedAt_ASC";
    AccessibilityObservationOrderByInput["ObservedAtDesc"] = "observedAt_DESC";
    AccessibilityObservationOrderByInput["PageUrlAsc"] = "pageUrl_ASC";
    AccessibilityObservationOrderByInput["PageUrlDesc"] = "pageUrl_DESC";
    AccessibilityObservationOrderByInput["PdfFindingKeyAsc"] = "pdfFindingKey_ASC";
    AccessibilityObservationOrderByInput["PdfFindingKeyDesc"] = "pdfFindingKey_DESC";
    AccessibilityObservationOrderByInput["PdfFindingRepresentativeAsc"] = "pdfFindingRepresentative_ASC";
    AccessibilityObservationOrderByInput["PdfFindingRepresentativeDesc"] = "pdfFindingRepresentative_DESC";
    AccessibilityObservationOrderByInput["RationaleAsc"] = "rationale_ASC";
    AccessibilityObservationOrderByInput["RationaleDesc"] = "rationale_DESC";
    AccessibilityObservationOrderByInput["SourceAsc"] = "source_ASC";
    AccessibilityObservationOrderByInput["SourceDesc"] = "source_DESC";
    AccessibilityObservationOrderByInput["StatusAsc"] = "status_ASC";
    AccessibilityObservationOrderByInput["StatusDesc"] = "status_DESC";
    AccessibilityObservationOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityObservationOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityObservationOrderByInput["UrlScopeKeyAsc"] = "urlScopeKey_ASC";
    AccessibilityObservationOrderByInput["UrlScopeKeyDesc"] = "urlScopeKey_DESC";
})(AccessibilityObservationOrderByInput || (AccessibilityObservationOrderByInput = {}));
export var AccessibilityPageReferenceKind;
(function (AccessibilityPageReferenceKind) {
    AccessibilityPageReferenceKind["Download"] = "DOWNLOAD";
    AccessibilityPageReferenceKind["Embed"] = "EMBED";
    AccessibilityPageReferenceKind["Iframe"] = "IFRAME";
    AccessibilityPageReferenceKind["Link"] = "LINK";
    AccessibilityPageReferenceKind["Object"] = "OBJECT";
})(AccessibilityPageReferenceKind || (AccessibilityPageReferenceKind = {}));
export var WebsiteCrawlQuotaFactKind;
(function (WebsiteCrawlQuotaFactKind) {
    WebsiteCrawlQuotaFactKind["BrokenReferrerPage"] = "BROKEN_REFERRER_PAGE";
    WebsiteCrawlQuotaFactKind["PdfResource"] = "PDF_RESOURCE";
})(WebsiteCrawlQuotaFactKind || (WebsiteCrawlQuotaFactKind = {}));
export var WebsiteCrawlDiscoveryKind;
(function (WebsiteCrawlDiscoveryKind) {
    WebsiteCrawlDiscoveryKind["Download"] = "DOWNLOAD";
    WebsiteCrawlDiscoveryKind["Embed"] = "EMBED";
    WebsiteCrawlDiscoveryKind["Iframe"] = "IFRAME";
    WebsiteCrawlDiscoveryKind["Link"] = "LINK";
    WebsiteCrawlDiscoveryKind["Object"] = "OBJECT";
})(WebsiteCrawlDiscoveryKind || (WebsiteCrawlDiscoveryKind = {}));
export var WebsiteCrawlOutcome;
(function (WebsiteCrawlOutcome) {
    WebsiteCrawlOutcome["Broken"] = "BROKEN";
    WebsiteCrawlOutcome["Ok"] = "OK";
    WebsiteCrawlOutcome["Skipped"] = "SKIPPED";
})(WebsiteCrawlOutcome || (WebsiteCrawlOutcome = {}));
export var WebsiteCrawlResourceType;
(function (WebsiteCrawlResourceType) {
    WebsiteCrawlResourceType["Html"] = "HTML";
    WebsiteCrawlResourceType["Other"] = "OTHER";
    WebsiteCrawlResourceType["Pdf"] = "PDF";
})(WebsiteCrawlResourceType || (WebsiteCrawlResourceType = {}));
export var WebsiteCrawlResourceState;
(function (WebsiteCrawlResourceState) {
    WebsiteCrawlResourceState["Completed"] = "COMPLETED";
    WebsiteCrawlResourceState["Fetching"] = "FETCHING";
    WebsiteCrawlResourceState["Pending"] = "PENDING";
})(WebsiteCrawlResourceState || (WebsiteCrawlResourceState = {}));
export var WebsiteCrawlReferenceState;
(function (WebsiteCrawlReferenceState) {
    WebsiteCrawlReferenceState["Pending"] = "PENDING";
    WebsiteCrawlReferenceState["Processed"] = "PROCESSED";
})(WebsiteCrawlReferenceState || (WebsiteCrawlReferenceState = {}));
export var WebsiteCrawlStopReason;
(function (WebsiteCrawlStopReason) {
    WebsiteCrawlStopReason["Exhausted"] = "EXHAUSTED";
    WebsiteCrawlStopReason["LicenseLimit"] = "LICENSE_LIMIT";
    WebsiteCrawlStopReason["SafetyLimit"] = "SAFETY_LIMIT";
})(WebsiteCrawlStopReason || (WebsiteCrawlStopReason = {}));
export var RoleType;
(function (RoleType) {
    RoleType["Customer"] = "CUSTOMER";
    RoleType["DataSource"] = "DATA_SOURCE";
    RoleType["Internal"] = "INTERNAL";
    RoleType["Partner"] = "PARTNER";
    RoleType["Website"] = "WEBSITE";
})(RoleType || (RoleType = {}));
export var LicenseInterval;
(function (LicenseInterval) {
    LicenseInterval["Monthly"] = "MONTHLY";
    LicenseInterval["Trial"] = "TRIAL";
    LicenseInterval["Yearly"] = "YEARLY";
})(LicenseInterval || (LicenseInterval = {}));
export var LicenseStatus;
(function (LicenseStatus) {
    LicenseStatus["Active"] = "ACTIVE";
    LicenseStatus["Deprecated"] = "DEPRECATED";
    LicenseStatus["Inactive"] = "INACTIVE";
})(LicenseStatus || (LicenseStatus = {}));
export var Module;
(function (Module) {
    Module["Accessibility"] = "ACCESSIBILITY";
    Module["Addon"] = "ADDON";
    Module["AnalysisReport"] = "ANALYSIS_REPORT";
    Module["Analytics"] = "ANALYTICS";
    Module["CxSurveys"] = "CX_SURVEYS";
    Module["Heatmaps"] = "HEATMAPS";
    Module["Onboarding"] = "ONBOARDING";
    Module["Support"] = "SUPPORT";
    Module["UxSurveys"] = "UX_SURVEYS";
})(Module || (Module = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["Amount"] = "AMOUNT";
    DiscountType["Percentage"] = "PERCENTAGE";
})(DiscountType || (DiscountType = {}));
export var OrderItemType;
(function (OrderItemType) {
    OrderItemType["Addon"] = "ADDON";
    OrderItemType["Info"] = "INFO";
    OrderItemType["License"] = "LICENSE";
    OrderItemType["Refund"] = "REFUND";
})(OrderItemType || (OrderItemType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Cancelled"] = "CANCELLED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Invoice"] = "INVOICE";
    PaymentStatus["Paid"] = "PAID";
    PaymentStatus["Pending"] = "PENDING";
    PaymentStatus["Refunded"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["Invoice"] = "INVOICE";
    PaymentType["Stripe"] = "STRIPE";
})(PaymentType || (PaymentType = {}));
export var PeriodType;
(function (PeriodType) {
    PeriodType["Day"] = "DAY";
    PeriodType["Month"] = "MONTH";
    PeriodType["Quarter"] = "QUARTER";
    PeriodType["Week"] = "WEEK";
    PeriodType["Year"] = "YEAR";
})(PeriodType || (PeriodType = {}));
export var SurveySetting;
(function (SurveySetting) {
    SurveySetting["Custom"] = "CUSTOM";
    SurveySetting["Default"] = "DEFAULT";
    SurveySetting["Desktop"] = "DESKTOP";
    SurveySetting["Disabled"] = "DISABLED";
    SurveySetting["Mobile"] = "MOBILE";
    SurveySetting["Primary"] = "PRIMARY";
    SurveySetting["Tablet"] = "TABLET";
})(SurveySetting || (SurveySetting = {}));
export var EmbedPosition;
(function (EmbedPosition) {
    EmbedPosition["After"] = "AFTER";
    EmbedPosition["Before"] = "BEFORE";
    EmbedPosition["FirstChild"] = "FIRST_CHILD";
    EmbedPosition["LastChild"] = "LAST_CHILD";
})(EmbedPosition || (EmbedPosition = {}));
export var LogoSource;
(function (LogoSource) {
    LogoSource["Customer"] = "CUSTOMER";
    LogoSource["None"] = "NONE";
    LogoSource["Url"] = "URL";
})(LogoSource || (LogoSource = {}));
export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["And"] = "AND";
    LogicalOperator["Or"] = "OR";
})(LogicalOperator || (LogicalOperator = {}));
export var QuestionSubType;
(function (QuestionSubType) {
    QuestionSubType["Email"] = "EMAIL";
    QuestionSubType["Number"] = "NUMBER";
    QuestionSubType["Text"] = "TEXT";
    QuestionSubType["Textarea"] = "TEXTAREA";
})(QuestionSubType || (QuestionSubType = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Checkbox"] = "CHECKBOX";
    QuestionType["Contact"] = "CONTACT";
    QuestionType["Country"] = "COUNTRY";
    QuestionType["Field"] = "FIELD";
    QuestionType["Find"] = "FIND";
    QuestionType["Grade"] = "GRADE";
    QuestionType["Nps"] = "NPS";
    QuestionType["Numbers"] = "NUMBERS";
    QuestionType["Radio"] = "RADIO";
    QuestionType["Sentiment"] = "SENTIMENT";
    QuestionType["Thumbs"] = "THUMBS";
    QuestionType["Zip"] = "ZIP";
})(QuestionType || (QuestionType = {}));
export var TaggedCommentType;
(function (TaggedCommentType) {
    TaggedCommentType["Sentiment"] = "SENTIMENT";
    TaggedCommentType["Theme"] = "THEME";
    TaggedCommentType["Wordcloud"] = "WORDCLOUD";
})(TaggedCommentType || (TaggedCommentType = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["Completed"] = "COMPLETED";
    JobStatus["Failed"] = "FAILED";
    JobStatus["Ongoing"] = "ONGOING";
    JobStatus["Pending"] = "PENDING";
    JobStatus["Running"] = "RUNNING";
})(JobStatus || (JobStatus = {}));
export var TrackPageViews;
(function (TrackPageViews) {
    TrackPageViews["Never"] = "NEVER";
    TrackPageViews["PageLoad"] = "PAGE_LOAD";
    TrackPageViews["UrlChange"] = "URL_CHANGE";
})(TrackPageViews || (TrackPageViews = {}));
export var PrivacySetting;
(function (PrivacySetting) {
    PrivacySetting["Always"] = "ALWAYS";
    PrivacySetting["Never"] = "NEVER";
    PrivacySetting["WithConsent"] = "WITH_CONSENT";
})(PrivacySetting || (PrivacySetting = {}));
export var ReportDistributionDelivery;
(function (ReportDistributionDelivery) {
    ReportDistributionDelivery["Email"] = "EMAIL";
})(ReportDistributionDelivery || (ReportDistributionDelivery = {}));
export var ReportDistributionFrequency;
(function (ReportDistributionFrequency) {
    ReportDistributionFrequency["Daily"] = "DAILY";
    ReportDistributionFrequency["Monthly"] = "MONTHLY";
    ReportDistributionFrequency["Quarterly"] = "QUARTERLY";
    ReportDistributionFrequency["Weekly"] = "WEEKLY";
    ReportDistributionFrequency["Yearly"] = "YEARLY";
})(ReportDistributionFrequency || (ReportDistributionFrequency = {}));
export var ReportDistributionTextResponseFormat;
(function (ReportDistributionTextResponseFormat) {
    ReportDistributionTextResponseFormat["Pdf"] = "PDF";
    ReportDistributionTextResponseFormat["Xls"] = "XLS";
})(ReportDistributionTextResponseFormat || (ReportDistributionTextResponseFormat = {}));
export var SurveyType;
(function (SurveyType) {
    SurveyType["Cx"] = "CX";
    SurveyType["Feedback"] = "FEEDBACK";
    SurveyType["General"] = "GENERAL";
    SurveyType["Targeted"] = "TARGETED";
})(SurveyType || (SurveyType = {}));
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["Cx"] = "CX";
    DataSourceType["Website"] = "WEBSITE";
})(DataSourceType || (DataSourceType = {}));
export var DashboardContentType;
(function (DashboardContentType) {
    DashboardContentType["Result"] = "RESULT";
    DashboardContentType["Text"] = "TEXT";
})(DashboardContentType || (DashboardContentType = {}));
export var CustomerPrivacyPolicyType;
(function (CustomerPrivacyPolicyType) {
    CustomerPrivacyPolicyType["Inline"] = "INLINE";
    CustomerPrivacyPolicyType["Url"] = "URL";
})(CustomerPrivacyPolicyType || (CustomerPrivacyPolicyType = {}));
export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["Active"] = "ACTIVE";
    CustomerStatus["Archived"] = "ARCHIVED";
    CustomerStatus["Blocked"] = "BLOCKED";
    CustomerStatus["Pending"] = "PENDING";
})(CustomerStatus || (CustomerStatus = {}));
export var Mfa;
(function (Mfa) {
    Mfa["Email"] = "EMAIL";
    Mfa["Sms"] = "SMS";
    Mfa["Totp"] = "TOTP";
})(Mfa || (Mfa = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Blocked"] = "BLOCKED";
    UserStatus["Invited"] = "INVITED";
})(UserStatus || (UserStatus = {}));
export var WebsiteCheckPurpose;
(function (WebsiteCheckPurpose) {
    WebsiteCheckPurpose["BrokenLinks"] = "BROKEN_LINKS";
    WebsiteCheckPurpose["PdfDiscovery"] = "PDF_DISCOVERY";
})(WebsiteCheckPurpose || (WebsiteCheckPurpose = {}));
export var WebsiteCheckStatus;
(function (WebsiteCheckStatus) {
    WebsiteCheckStatus["Completed"] = "COMPLETED";
    WebsiteCheckStatus["Failed"] = "FAILED";
    WebsiteCheckStatus["Pending"] = "PENDING";
    WebsiteCheckStatus["Running"] = "RUNNING";
})(WebsiteCheckStatus || (WebsiteCheckStatus = {}));
export var WebsiteCheckType;
(function (WebsiteCheckType) {
    WebsiteCheckType["Manual"] = "MANUAL";
    WebsiteCheckType["Scheduled"] = "SCHEDULED";
})(WebsiteCheckType || (WebsiteCheckType = {}));
export var AccessibilityTestRunStatus;
(function (AccessibilityTestRunStatus) {
    AccessibilityTestRunStatus["Completed"] = "COMPLETED";
    AccessibilityTestRunStatus["Failed"] = "FAILED";
    AccessibilityTestRunStatus["Pending"] = "PENDING";
    AccessibilityTestRunStatus["Running"] = "RUNNING";
})(AccessibilityTestRunStatus || (AccessibilityTestRunStatus = {}));
export var AccessibilityRunTrigger;
(function (AccessibilityRunTrigger) {
    AccessibilityRunTrigger["Manual"] = "MANUAL";
    AccessibilityRunTrigger["Scheduled"] = "SCHEDULED";
})(AccessibilityRunTrigger || (AccessibilityRunTrigger = {}));
export var AccessibilityPdfScanRunItemStatus;
(function (AccessibilityPdfScanRunItemStatus) {
    AccessibilityPdfScanRunItemStatus["AlreadyCompleted"] = "ALREADY_COMPLETED";
    AccessibilityPdfScanRunItemStatus["Completed"] = "COMPLETED";
    AccessibilityPdfScanRunItemStatus["Failed"] = "FAILED";
    AccessibilityPdfScanRunItemStatus["Queued"] = "QUEUED";
    AccessibilityPdfScanRunItemStatus["Running"] = "RUNNING";
    AccessibilityPdfScanRunItemStatus["Skipped"] = "SKIPPED";
})(AccessibilityPdfScanRunItemStatus || (AccessibilityPdfScanRunItemStatus = {}));
export var AccessibilityPageType;
(function (AccessibilityPageType) {
    AccessibilityPageType["Html"] = "HTML";
    AccessibilityPageType["Pdf"] = "PDF";
})(AccessibilityPageType || (AccessibilityPageType = {}));
export var AccessibilityPdfScanRunItemOrderByInput;
(function (AccessibilityPdfScanRunItemOrderByInput) {
    AccessibilityPdfScanRunItemOrderByInput["CompletedAtAsc"] = "completedAt_ASC";
    AccessibilityPdfScanRunItemOrderByInput["CompletedAtDesc"] = "completedAt_DESC";
    AccessibilityPdfScanRunItemOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityPdfScanRunItemOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityPdfScanRunItemOrderByInput["ErrorCodeAsc"] = "errorCode_ASC";
    AccessibilityPdfScanRunItemOrderByInput["ErrorCodeDesc"] = "errorCode_DESC";
    AccessibilityPdfScanRunItemOrderByInput["ErrorMessageAsc"] = "errorMessage_ASC";
    AccessibilityPdfScanRunItemOrderByInput["ErrorMessageDesc"] = "errorMessage_DESC";
    AccessibilityPdfScanRunItemOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityPdfScanRunItemOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityPdfScanRunItemOrderByInput["ItemKeyAsc"] = "itemKey_ASC";
    AccessibilityPdfScanRunItemOrderByInput["ItemKeyDesc"] = "itemKey_DESC";
    AccessibilityPdfScanRunItemOrderByInput["QueuedAtAsc"] = "queuedAt_ASC";
    AccessibilityPdfScanRunItemOrderByInput["QueuedAtDesc"] = "queuedAt_DESC";
    AccessibilityPdfScanRunItemOrderByInput["StartedAtAsc"] = "startedAt_ASC";
    AccessibilityPdfScanRunItemOrderByInput["StartedAtDesc"] = "startedAt_DESC";
    AccessibilityPdfScanRunItemOrderByInput["StatusAsc"] = "status_ASC";
    AccessibilityPdfScanRunItemOrderByInput["StatusDesc"] = "status_DESC";
    AccessibilityPdfScanRunItemOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityPdfScanRunItemOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AccessibilityPdfScanRunItemOrderByInput || (AccessibilityPdfScanRunItemOrderByInput = {}));
export var AccessibilityPageOrderByInput;
(function (AccessibilityPageOrderByInput) {
    AccessibilityPageOrderByInput["ClassificationStatusAsc"] = "classificationStatus_ASC";
    AccessibilityPageOrderByInput["ClassificationStatusDesc"] = "classificationStatus_DESC";
    AccessibilityPageOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityPageOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityPageOrderByInput["CurrentGroupingAsc"] = "currentGrouping_ASC";
    AccessibilityPageOrderByInput["CurrentGroupingDesc"] = "currentGrouping_DESC";
    AccessibilityPageOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityPageOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityPageOrderByInput["PageKeyAsc"] = "pageKey_ASC";
    AccessibilityPageOrderByInput["PageKeyDesc"] = "pageKey_DESC";
    AccessibilityPageOrderByInput["PageTypeAsc"] = "pageType_ASC";
    AccessibilityPageOrderByInput["PageTypeDesc"] = "pageType_DESC";
    AccessibilityPageOrderByInput["RetiredAtAsc"] = "retiredAt_ASC";
    AccessibilityPageOrderByInput["RetiredAtDesc"] = "retiredAt_DESC";
    AccessibilityPageOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityPageOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AccessibilityPageOrderByInput || (AccessibilityPageOrderByInput = {}));
export var AccessibilityPdfScanRunOrderByInput;
(function (AccessibilityPdfScanRunOrderByInput) {
    AccessibilityPdfScanRunOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityPdfScanRunOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityPdfScanRunOrderByInput["ExpectedItemCountAsc"] = "expectedItemCount_ASC";
    AccessibilityPdfScanRunOrderByInput["ExpectedItemCountDesc"] = "expectedItemCount_DESC";
    AccessibilityPdfScanRunOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityPdfScanRunOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityPdfScanRunOrderByInput["ReasonAsc"] = "reason_ASC";
    AccessibilityPdfScanRunOrderByInput["ReasonDesc"] = "reason_DESC";
    AccessibilityPdfScanRunOrderByInput["RunKeyAsc"] = "runKey_ASC";
    AccessibilityPdfScanRunOrderByInput["RunKeyDesc"] = "runKey_DESC";
    AccessibilityPdfScanRunOrderByInput["ScheduledAtAsc"] = "scheduledAt_ASC";
    AccessibilityPdfScanRunOrderByInput["ScheduledAtDesc"] = "scheduledAt_DESC";
    AccessibilityPdfScanRunOrderByInput["TriggerAsc"] = "trigger_ASC";
    AccessibilityPdfScanRunOrderByInput["TriggerDesc"] = "trigger_DESC";
    AccessibilityPdfScanRunOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityPdfScanRunOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AccessibilityPdfScanRunOrderByInput || (AccessibilityPdfScanRunOrderByInput = {}));
export var AccessibilityProviderProblemOrderByInput;
(function (AccessibilityProviderProblemOrderByInput) {
    AccessibilityProviderProblemOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityProviderProblemOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityProviderProblemOrderByInput["DetectionStateAsc"] = "detectionState_ASC";
    AccessibilityProviderProblemOrderByInput["DetectionStateDesc"] = "detectionState_DESC";
    AccessibilityProviderProblemOrderByInput["DispositionAsc"] = "disposition_ASC";
    AccessibilityProviderProblemOrderByInput["DispositionDesc"] = "disposition_DESC";
    AccessibilityProviderProblemOrderByInput["FirstSeenAtAsc"] = "firstSeenAt_ASC";
    AccessibilityProviderProblemOrderByInput["FirstSeenAtDesc"] = "firstSeenAt_DESC";
    AccessibilityProviderProblemOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityProviderProblemOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityProviderProblemOrderByInput["LastSeenAtAsc"] = "lastSeenAt_ASC";
    AccessibilityProviderProblemOrderByInput["LastSeenAtDesc"] = "lastSeenAt_DESC";
    AccessibilityProviderProblemOrderByInput["PageTitleAsc"] = "pageTitle_ASC";
    AccessibilityProviderProblemOrderByInput["PageTitleDesc"] = "pageTitle_DESC";
    AccessibilityProviderProblemOrderByInput["PageUrlAsc"] = "pageUrl_ASC";
    AccessibilityProviderProblemOrderByInput["PageUrlDesc"] = "pageUrl_DESC";
    AccessibilityProviderProblemOrderByInput["PayloadAsc"] = "payload_ASC";
    AccessibilityProviderProblemOrderByInput["PayloadDesc"] = "payload_DESC";
    AccessibilityProviderProblemOrderByInput["ProviderProblemKeyAsc"] = "providerProblemKey_ASC";
    AccessibilityProviderProblemOrderByInput["ProviderProblemKeyDesc"] = "providerProblemKey_DESC";
    AccessibilityProviderProblemOrderByInput["ProviderProblemNumberAsc"] = "providerProblemNumber_ASC";
    AccessibilityProviderProblemOrderByInput["ProviderProblemNumberDesc"] = "providerProblemNumber_DESC";
    AccessibilityProviderProblemOrderByInput["RuleIdAsc"] = "ruleId_ASC";
    AccessibilityProviderProblemOrderByInput["RuleIdDesc"] = "ruleId_DESC";
    AccessibilityProviderProblemOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityProviderProblemOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityProviderProblemOrderByInput["UrlScopeKeyAsc"] = "urlScopeKey_ASC";
    AccessibilityProviderProblemOrderByInput["UrlScopeKeyDesc"] = "urlScopeKey_DESC";
})(AccessibilityProviderProblemOrderByInput || (AccessibilityProviderProblemOrderByInput = {}));
export var AccessibilityReviewUnitOrderByInput;
(function (AccessibilityReviewUnitOrderByInput) {
    AccessibilityReviewUnitOrderByInput["CompletedAtAsc"] = "completedAt_ASC";
    AccessibilityReviewUnitOrderByInput["CompletedAtDesc"] = "completedAt_DESC";
    AccessibilityReviewUnitOrderByInput["CompletedByAsc"] = "completedBy_ASC";
    AccessibilityReviewUnitOrderByInput["CompletedByDesc"] = "completedBy_DESC";
    AccessibilityReviewUnitOrderByInput["CoverageKeyAsc"] = "coverageKey_ASC";
    AccessibilityReviewUnitOrderByInput["CoverageKeyDesc"] = "coverageKey_DESC";
    AccessibilityReviewUnitOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityReviewUnitOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityReviewUnitOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityReviewUnitOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityReviewUnitOrderByInput["KindAsc"] = "kind_ASC";
    AccessibilityReviewUnitOrderByInput["KindDesc"] = "kind_DESC";
    AccessibilityReviewUnitOrderByInput["RationaleAsc"] = "rationale_ASC";
    AccessibilityReviewUnitOrderByInput["RationaleDesc"] = "rationale_DESC";
    AccessibilityReviewUnitOrderByInput["SourceAsc"] = "source_ASC";
    AccessibilityReviewUnitOrderByInput["SourceDesc"] = "source_DESC";
    AccessibilityReviewUnitOrderByInput["StatusAsc"] = "status_ASC";
    AccessibilityReviewUnitOrderByInput["StatusDesc"] = "status_DESC";
    AccessibilityReviewUnitOrderByInput["TitleAsc"] = "title_ASC";
    AccessibilityReviewUnitOrderByInput["TitleDesc"] = "title_DESC";
    AccessibilityReviewUnitOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityReviewUnitOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityReviewUnitOrderByInput["WorkStatusAsc"] = "workStatus_ASC";
    AccessibilityReviewUnitOrderByInput["WorkStatusDesc"] = "workStatus_DESC";
})(AccessibilityReviewUnitOrderByInput || (AccessibilityReviewUnitOrderByInput = {}));
export var AccessibilityReviewUnitUrlOrderByInput;
(function (AccessibilityReviewUnitUrlOrderByInput) {
    AccessibilityReviewUnitUrlOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityReviewUnitUrlOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityReviewUnitUrlOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityReviewUnitUrlOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityReviewUnitUrlOrderByInput["NormalizedUrlAsc"] = "normalizedUrl_ASC";
    AccessibilityReviewUnitUrlOrderByInput["NormalizedUrlDesc"] = "normalizedUrl_DESC";
    AccessibilityReviewUnitUrlOrderByInput["RepresentativeAsc"] = "representative_ASC";
    AccessibilityReviewUnitUrlOrderByInput["RepresentativeDesc"] = "representative_DESC";
    AccessibilityReviewUnitUrlOrderByInput["SourceAsc"] = "source_ASC";
    AccessibilityReviewUnitUrlOrderByInput["SourceDesc"] = "source_DESC";
    AccessibilityReviewUnitUrlOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityReviewUnitUrlOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityReviewUnitUrlOrderByInput["UrlAsc"] = "url_ASC";
    AccessibilityReviewUnitUrlOrderByInput["UrlDesc"] = "url_DESC";
})(AccessibilityReviewUnitUrlOrderByInput || (AccessibilityReviewUnitUrlOrderByInput = {}));
export var AccessibilitySyncOrderByInput;
(function (AccessibilitySyncOrderByInput) {
    AccessibilitySyncOrderByInput["CompletedAtAsc"] = "completedAt_ASC";
    AccessibilitySyncOrderByInput["CompletedAtDesc"] = "completedAt_DESC";
    AccessibilitySyncOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilitySyncOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilitySyncOrderByInput["ErrorAsc"] = "error_ASC";
    AccessibilitySyncOrderByInput["ErrorDesc"] = "error_DESC";
    AccessibilitySyncOrderByInput["IdAsc"] = "id_ASC";
    AccessibilitySyncOrderByInput["IdDesc"] = "id_DESC";
    AccessibilitySyncOrderByInput["ProviderAsc"] = "provider_ASC";
    AccessibilitySyncOrderByInput["ProviderDesc"] = "provider_DESC";
    AccessibilitySyncOrderByInput["ProviderReportedProblemCountAsc"] = "providerReportedProblemCount_ASC";
    AccessibilitySyncOrderByInput["ProviderReportedProblemCountDesc"] = "providerReportedProblemCount_DESC";
    AccessibilitySyncOrderByInput["RetrievedProblemCountAsc"] = "retrievedProblemCount_ASC";
    AccessibilitySyncOrderByInput["RetrievedProblemCountDesc"] = "retrievedProblemCount_DESC";
    AccessibilitySyncOrderByInput["StatusAsc"] = "status_ASC";
    AccessibilitySyncOrderByInput["StatusDesc"] = "status_DESC";
    AccessibilitySyncOrderByInput["SyncCompleteAsc"] = "syncComplete_ASC";
    AccessibilitySyncOrderByInput["SyncCompleteDesc"] = "syncComplete_DESC";
    AccessibilitySyncOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilitySyncOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilitySyncOrderByInput["VisibleProblemCountAsc"] = "visibleProblemCount_ASC";
    AccessibilitySyncOrderByInput["VisibleProblemCountDesc"] = "visibleProblemCount_DESC";
})(AccessibilitySyncOrderByInput || (AccessibilitySyncOrderByInput = {}));
export var AccessibilityPageLocationOrderByInput;
(function (AccessibilityPageLocationOrderByInput) {
    AccessibilityPageLocationOrderByInput["AvailabilityStateAsc"] = "availabilityState_ASC";
    AccessibilityPageLocationOrderByInput["AvailabilityStateDesc"] = "availabilityState_DESC";
    AccessibilityPageLocationOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityPageLocationOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityPageLocationOrderByInput["CurrentlyAvailableAsc"] = "currentlyAvailable_ASC";
    AccessibilityPageLocationOrderByInput["CurrentlyAvailableDesc"] = "currentlyAvailable_DESC";
    AccessibilityPageLocationOrderByInput["FinalUrlAsc"] = "finalUrl_ASC";
    AccessibilityPageLocationOrderByInput["FinalUrlDesc"] = "finalUrl_DESC";
    AccessibilityPageLocationOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityPageLocationOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityPageLocationOrderByInput["LocationKeyAsc"] = "locationKey_ASC";
    AccessibilityPageLocationOrderByInput["LocationKeyDesc"] = "locationKey_DESC";
    AccessibilityPageLocationOrderByInput["NormalizedFinalUrlAsc"] = "normalizedFinalUrl_ASC";
    AccessibilityPageLocationOrderByInput["NormalizedFinalUrlDesc"] = "normalizedFinalUrl_DESC";
    AccessibilityPageLocationOrderByInput["NormalizedRequestedUrlAsc"] = "normalizedRequestedUrl_ASC";
    AccessibilityPageLocationOrderByInput["NormalizedRequestedUrlDesc"] = "normalizedRequestedUrl_DESC";
    AccessibilityPageLocationOrderByInput["RedirectChainAsc"] = "redirectChain_ASC";
    AccessibilityPageLocationOrderByInput["RedirectChainDesc"] = "redirectChain_DESC";
    AccessibilityPageLocationOrderByInput["RequestedUrlAsc"] = "requestedUrl_ASC";
    AccessibilityPageLocationOrderByInput["RequestedUrlDesc"] = "requestedUrl_DESC";
    AccessibilityPageLocationOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityPageLocationOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityPageLocationOrderByInput["UrlScopeKeyAsc"] = "urlScopeKey_ASC";
    AccessibilityPageLocationOrderByInput["UrlScopeKeyDesc"] = "urlScopeKey_DESC";
})(AccessibilityPageLocationOrderByInput || (AccessibilityPageLocationOrderByInput = {}));
export var AccessibilityPdfScanEvidenceOrderByInput;
(function (AccessibilityPdfScanEvidenceOrderByInput) {
    AccessibilityPdfScanEvidenceOrderByInput["CompletedAtAsc"] = "completedAt_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["CompletedAtDesc"] = "completedAt_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["ContentHashAsc"] = "contentHash_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["ContentHashDesc"] = "contentHash_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["ProfileAsc"] = "profile_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["ProfileDesc"] = "profile_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["RawReportAssetKeyAsc"] = "rawReportAssetKey_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["RawReportAssetKeyDesc"] = "rawReportAssetKey_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["RuleMapVersionAsc"] = "ruleMapVersion_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["RuleMapVersionDesc"] = "ruleMapVersion_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["ScanKeyAsc"] = "scanKey_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["ScanKeyDesc"] = "scanKey_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["ValidatorAsc"] = "validator_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["ValidatorDesc"] = "validator_DESC";
    AccessibilityPdfScanEvidenceOrderByInput["ValidatorVersionAsc"] = "validatorVersion_ASC";
    AccessibilityPdfScanEvidenceOrderByInput["ValidatorVersionDesc"] = "validatorVersion_DESC";
})(AccessibilityPdfScanEvidenceOrderByInput || (AccessibilityPdfScanEvidenceOrderByInput = {}));
export var AccessibilityPageReferenceOrderByInput;
(function (AccessibilityPageReferenceOrderByInput) {
    AccessibilityPageReferenceOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityPageReferenceOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityPageReferenceOrderByInput["DiscoveryKindAsc"] = "discoveryKind_ASC";
    AccessibilityPageReferenceOrderByInput["DiscoveryKindDesc"] = "discoveryKind_DESC";
    AccessibilityPageReferenceOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityPageReferenceOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityPageReferenceOrderByInput["NormalizedReferringUrlAsc"] = "normalizedReferringUrl_ASC";
    AccessibilityPageReferenceOrderByInput["NormalizedReferringUrlDesc"] = "normalizedReferringUrl_DESC";
    AccessibilityPageReferenceOrderByInput["ReferenceKeyAsc"] = "referenceKey_ASC";
    AccessibilityPageReferenceOrderByInput["ReferenceKeyDesc"] = "referenceKey_DESC";
    AccessibilityPageReferenceOrderByInput["ReferringUrlAsc"] = "referringUrl_ASC";
    AccessibilityPageReferenceOrderByInput["ReferringUrlDesc"] = "referringUrl_DESC";
    AccessibilityPageReferenceOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityPageReferenceOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityPageReferenceOrderByInput["UrlScopeKeyAsc"] = "urlScopeKey_ASC";
    AccessibilityPageReferenceOrderByInput["UrlScopeKeyDesc"] = "urlScopeKey_DESC";
})(AccessibilityPageReferenceOrderByInput || (AccessibilityPageReferenceOrderByInput = {}));
export var AccessibilityTestRunOrderByInput;
(function (AccessibilityTestRunOrderByInput) {
    AccessibilityTestRunOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityTestRunOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityTestRunOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityTestRunOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityTestRunOrderByInput["ProviderCheckIdAsc"] = "providerCheckId_ASC";
    AccessibilityTestRunOrderByInput["ProviderCheckIdDesc"] = "providerCheckId_DESC";
    AccessibilityTestRunOrderByInput["StatusAsc"] = "status_ASC";
    AccessibilityTestRunOrderByInput["StatusDesc"] = "status_DESC";
    AccessibilityTestRunOrderByInput["TriggerAsc"] = "trigger_ASC";
    AccessibilityTestRunOrderByInput["TriggerDesc"] = "trigger_DESC";
    AccessibilityTestRunOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityTestRunOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AccessibilityTestRunOrderByInput || (AccessibilityTestRunOrderByInput = {}));
export var WebsiteCheckKind;
(function (WebsiteCheckKind) {
    WebsiteCheckKind["Accessibility"] = "ACCESSIBILITY";
    WebsiteCheckKind["BrokenLinks"] = "BROKEN_LINKS";
    WebsiteCheckKind["Pdf"] = "PDF";
})(WebsiteCheckKind || (WebsiteCheckKind = {}));
export var WebsiteCrawlQuotaFactOrderByInput;
(function (WebsiteCrawlQuotaFactOrderByInput) {
    WebsiteCrawlQuotaFactOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebsiteCrawlQuotaFactOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebsiteCrawlQuotaFactOrderByInput["FactKeyAsc"] = "factKey_ASC";
    WebsiteCrawlQuotaFactOrderByInput["FactKeyDesc"] = "factKey_DESC";
    WebsiteCrawlQuotaFactOrderByInput["IdAsc"] = "id_ASC";
    WebsiteCrawlQuotaFactOrderByInput["IdDesc"] = "id_DESC";
    WebsiteCrawlQuotaFactOrderByInput["KindAsc"] = "kind_ASC";
    WebsiteCrawlQuotaFactOrderByInput["KindDesc"] = "kind_DESC";
    WebsiteCrawlQuotaFactOrderByInput["NormalizedUrlAsc"] = "normalizedUrl_ASC";
    WebsiteCrawlQuotaFactOrderByInput["NormalizedUrlDesc"] = "normalizedUrl_DESC";
    WebsiteCrawlQuotaFactOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebsiteCrawlQuotaFactOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(WebsiteCrawlQuotaFactOrderByInput || (WebsiteCrawlQuotaFactOrderByInput = {}));
export var WebsiteCrawlReferenceOrderByInput;
(function (WebsiteCrawlReferenceOrderByInput) {
    WebsiteCrawlReferenceOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebsiteCrawlReferenceOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebsiteCrawlReferenceOrderByInput["DiscoveryKindAsc"] = "discoveryKind_ASC";
    WebsiteCrawlReferenceOrderByInput["DiscoveryKindDesc"] = "discoveryKind_DESC";
    WebsiteCrawlReferenceOrderByInput["IdAsc"] = "id_ASC";
    WebsiteCrawlReferenceOrderByInput["IdDesc"] = "id_DESC";
    WebsiteCrawlReferenceOrderByInput["NormalizedReferringUrlAsc"] = "normalizedReferringUrl_ASC";
    WebsiteCrawlReferenceOrderByInput["NormalizedReferringUrlDesc"] = "normalizedReferringUrl_DESC";
    WebsiteCrawlReferenceOrderByInput["ReferenceKeyAsc"] = "referenceKey_ASC";
    WebsiteCrawlReferenceOrderByInput["ReferenceKeyDesc"] = "referenceKey_DESC";
    WebsiteCrawlReferenceOrderByInput["StateAsc"] = "state_ASC";
    WebsiteCrawlReferenceOrderByInput["StateDesc"] = "state_DESC";
    WebsiteCrawlReferenceOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebsiteCrawlReferenceOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(WebsiteCrawlReferenceOrderByInput || (WebsiteCrawlReferenceOrderByInput = {}));
export var WebsiteCrawlResourceOrderByInput;
(function (WebsiteCrawlResourceOrderByInput) {
    WebsiteCrawlResourceOrderByInput["ContentDispositionAsc"] = "contentDisposition_ASC";
    WebsiteCrawlResourceOrderByInput["ContentDispositionDesc"] = "contentDisposition_DESC";
    WebsiteCrawlResourceOrderByInput["ContentTypeAsc"] = "contentType_ASC";
    WebsiteCrawlResourceOrderByInput["ContentTypeDesc"] = "contentType_DESC";
    WebsiteCrawlResourceOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebsiteCrawlResourceOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebsiteCrawlResourceOrderByInput["DepthAsc"] = "depth_ASC";
    WebsiteCrawlResourceOrderByInput["DepthDesc"] = "depth_DESC";
    WebsiteCrawlResourceOrderByInput["FrontierTruncatedResourceCapAsc"] = "frontierTruncatedResourceCap_ASC";
    WebsiteCrawlResourceOrderByInput["FrontierTruncatedResourceCapDesc"] = "frontierTruncatedResourceCap_DESC";
    WebsiteCrawlResourceOrderByInput["IdAsc"] = "id_ASC";
    WebsiteCrawlResourceOrderByInput["IdDesc"] = "id_DESC";
    WebsiteCrawlResourceOrderByInput["InScopeAsc"] = "inScope_ASC";
    WebsiteCrawlResourceOrderByInput["InScopeDesc"] = "inScope_DESC";
    WebsiteCrawlResourceOrderByInput["NormalizedUrlAsc"] = "normalizedUrl_ASC";
    WebsiteCrawlResourceOrderByInput["NormalizedUrlDesc"] = "normalizedUrl_DESC";
    WebsiteCrawlResourceOrderByInput["OutcomeAsc"] = "outcome_ASC";
    WebsiteCrawlResourceOrderByInput["OutcomeDesc"] = "outcome_DESC";
    WebsiteCrawlResourceOrderByInput["ReferenceLimitAsc"] = "referenceLimit_ASC";
    WebsiteCrawlResourceOrderByInput["ReferenceLimitDesc"] = "referenceLimit_DESC";
    WebsiteCrawlResourceOrderByInput["ReferencesTruncatedAsc"] = "referencesTruncated_ASC";
    WebsiteCrawlResourceOrderByInput["ReferencesTruncatedDesc"] = "referencesTruncated_DESC";
    WebsiteCrawlResourceOrderByInput["ResourceKeyAsc"] = "resourceKey_ASC";
    WebsiteCrawlResourceOrderByInput["ResourceKeyDesc"] = "resourceKey_DESC";
    WebsiteCrawlResourceOrderByInput["ResourceTypeAsc"] = "resourceType_ASC";
    WebsiteCrawlResourceOrderByInput["ResourceTypeDesc"] = "resourceType_DESC";
    WebsiteCrawlResourceOrderByInput["StateAsc"] = "state_ASC";
    WebsiteCrawlResourceOrderByInput["StateDesc"] = "state_DESC";
    WebsiteCrawlResourceOrderByInput["StatusAsc"] = "status_ASC";
    WebsiteCrawlResourceOrderByInput["StatusDesc"] = "status_DESC";
    WebsiteCrawlResourceOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebsiteCrawlResourceOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(WebsiteCrawlResourceOrderByInput || (WebsiteCrawlResourceOrderByInput = {}));
export var CustomerAccessOrderByInput;
(function (CustomerAccessOrderByInput) {
    CustomerAccessOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CustomerAccessOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CustomerAccessOrderByInput["IdAsc"] = "id_ASC";
    CustomerAccessOrderByInput["IdDesc"] = "id_DESC";
    CustomerAccessOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CustomerAccessOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(CustomerAccessOrderByInput || (CustomerAccessOrderByInput = {}));
export var ApiKeyOrderByInput;
(function (ApiKeyOrderByInput) {
    ApiKeyOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ApiKeyOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ApiKeyOrderByInput["IdAsc"] = "id_ASC";
    ApiKeyOrderByInput["IdDesc"] = "id_DESC";
    ApiKeyOrderByInput["LastUsedAtAsc"] = "lastUsedAt_ASC";
    ApiKeyOrderByInput["LastUsedAtDesc"] = "lastUsedAt_DESC";
    ApiKeyOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ApiKeyOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ApiKeyOrderByInput || (ApiKeyOrderByInput = {}));
export var CustomerCategoryOrderByInput;
(function (CustomerCategoryOrderByInput) {
    CustomerCategoryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CustomerCategoryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CustomerCategoryOrderByInput["IdAsc"] = "id_ASC";
    CustomerCategoryOrderByInput["IdDesc"] = "id_DESC";
    CustomerCategoryOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    CustomerCategoryOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    CustomerCategoryOrderByInput["TitleAsc"] = "title_ASC";
    CustomerCategoryOrderByInput["TitleDesc"] = "title_DESC";
    CustomerCategoryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CustomerCategoryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(CustomerCategoryOrderByInput || (CustomerCategoryOrderByInput = {}));
export var CustomerOrderByInput;
(function (CustomerOrderByInput) {
    CustomerOrderByInput["AliasAsc"] = "alias_ASC";
    CustomerOrderByInput["AliasDesc"] = "alias_DESC";
    CustomerOrderByInput["AllowPersonalDataAsc"] = "allowPersonalData_ASC";
    CustomerOrderByInput["AllowPersonalDataDesc"] = "allowPersonalData_DESC";
    CustomerOrderByInput["BillingCommentAsc"] = "billingComment_ASC";
    CustomerOrderByInput["BillingCommentDesc"] = "billingComment_DESC";
    CustomerOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CustomerOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CustomerOrderByInput["IdAsc"] = "id_ASC";
    CustomerOrderByInput["IdDesc"] = "id_DESC";
    CustomerOrderByInput["LastUserActivityAlertAsc"] = "lastUserActivityAlert_ASC";
    CustomerOrderByInput["LastUserActivityAlertDesc"] = "lastUserActivityAlert_DESC";
    CustomerOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    CustomerOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    CustomerOrderByInput["NameAsc"] = "name_ASC";
    CustomerOrderByInput["NameDesc"] = "name_DESC";
    CustomerOrderByInput["PaymentTypeAsc"] = "paymentType_ASC";
    CustomerOrderByInput["PaymentTypeDesc"] = "paymentType_DESC";
    CustomerOrderByInput["PersonalDataControllerAsc"] = "personalDataController_ASC";
    CustomerOrderByInput["PersonalDataControllerDesc"] = "personalDataController_DESC";
    CustomerOrderByInput["PipedriveOrganizationIdAsc"] = "pipedriveOrganizationId_ASC";
    CustomerOrderByInput["PipedriveOrganizationIdDesc"] = "pipedriveOrganizationId_DESC";
    CustomerOrderByInput["StatusAsc"] = "status_ASC";
    CustomerOrderByInput["StatusDesc"] = "status_DESC";
    CustomerOrderByInput["StripeCustomerIdAsc"] = "stripeCustomerId_ASC";
    CustomerOrderByInput["StripeCustomerIdDesc"] = "stripeCustomerId_DESC";
    CustomerOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CustomerOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    CustomerOrderByInput["VatAsc"] = "vat_ASC";
    CustomerOrderByInput["VatDesc"] = "vat_DESC";
})(CustomerOrderByInput || (CustomerOrderByInput = {}));
export var DashboardsPageOrderByInput;
(function (DashboardsPageOrderByInput) {
    DashboardsPageOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DashboardsPageOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DashboardsPageOrderByInput["IdAsc"] = "id_ASC";
    DashboardsPageOrderByInput["IdDesc"] = "id_DESC";
    DashboardsPageOrderByInput["TitleAsc"] = "title_ASC";
    DashboardsPageOrderByInput["TitleDesc"] = "title_DESC";
    DashboardsPageOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DashboardsPageOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DashboardsPageOrderByInput || (DashboardsPageOrderByInput = {}));
export var DashboardOrderByInput;
(function (DashboardOrderByInput) {
    DashboardOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DashboardOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DashboardOrderByInput["IdAsc"] = "id_ASC";
    DashboardOrderByInput["IdDesc"] = "id_DESC";
    DashboardOrderByInput["ParentAsc"] = "parent_ASC";
    DashboardOrderByInput["ParentDesc"] = "parent_DESC";
    DashboardOrderByInput["SettingsAsc"] = "settings_ASC";
    DashboardOrderByInput["SettingsDesc"] = "settings_DESC";
    DashboardOrderByInput["TitleAsc"] = "title_ASC";
    DashboardOrderByInput["TitleDesc"] = "title_DESC";
    DashboardOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DashboardOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DashboardOrderByInput || (DashboardOrderByInput = {}));
export var DashboardContentOrderByInput;
(function (DashboardContentOrderByInput) {
    DashboardContentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DashboardContentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DashboardContentOrderByInput["IdAsc"] = "id_ASC";
    DashboardContentOrderByInput["IdDesc"] = "id_DESC";
    DashboardContentOrderByInput["LayoutAsc"] = "layout_ASC";
    DashboardContentOrderByInput["LayoutDesc"] = "layout_DESC";
    DashboardContentOrderByInput["RichTextAsc"] = "richText_ASC";
    DashboardContentOrderByInput["RichTextDesc"] = "richText_DESC";
    DashboardContentOrderByInput["TitleAsc"] = "title_ASC";
    DashboardContentOrderByInput["TitleDesc"] = "title_DESC";
    DashboardContentOrderByInput["TypeAsc"] = "type_ASC";
    DashboardContentOrderByInput["TypeDesc"] = "type_DESC";
    DashboardContentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DashboardContentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DashboardContentOrderByInput || (DashboardContentOrderByInput = {}));
export var DataSourceOrderByInput;
(function (DataSourceOrderByInput) {
    DataSourceOrderByInput["CollectionActivityAsc"] = "collectionActivity_ASC";
    DataSourceOrderByInput["CollectionActivityDesc"] = "collectionActivity_DESC";
    DataSourceOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DataSourceOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DataSourceOrderByInput["HubspotDealRecordIdAsc"] = "hubspotDealRecordId_ASC";
    DataSourceOrderByInput["HubspotDealRecordIdDesc"] = "hubspotDealRecordId_DESC";
    DataSourceOrderByInput["IdAsc"] = "id_ASC";
    DataSourceOrderByInput["IdDesc"] = "id_DESC";
    DataSourceOrderByInput["IsTestAsc"] = "isTest_ASC";
    DataSourceOrderByInput["IsTestDesc"] = "isTest_DESC";
    DataSourceOrderByInput["PipedriveDealIdAsc"] = "pipedriveDealId_ASC";
    DataSourceOrderByInput["PipedriveDealIdDesc"] = "pipedriveDealId_DESC";
    DataSourceOrderByInput["TitleAsc"] = "title_ASC";
    DataSourceOrderByInput["TitleDesc"] = "title_DESC";
    DataSourceOrderByInput["TypeAsc"] = "type_ASC";
    DataSourceOrderByInput["TypeDesc"] = "type_DESC";
    DataSourceOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DataSourceOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DataSourceOrderByInput || (DataSourceOrderByInput = {}));
export var DataSourceAccessOrderByInput;
(function (DataSourceAccessOrderByInput) {
    DataSourceAccessOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DataSourceAccessOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DataSourceAccessOrderByInput["IdAsc"] = "id_ASC";
    DataSourceAccessOrderByInput["IdDesc"] = "id_DESC";
    DataSourceAccessOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DataSourceAccessOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DataSourceAccessOrderByInput || (DataSourceAccessOrderByInput = {}));
export var RoleOrderByInput;
(function (RoleOrderByInput) {
    RoleOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    RoleOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    RoleOrderByInput["DescriptionAsc"] = "description_ASC";
    RoleOrderByInput["DescriptionDesc"] = "description_DESC";
    RoleOrderByInput["IdAsc"] = "id_ASC";
    RoleOrderByInput["IdDesc"] = "id_DESC";
    RoleOrderByInput["NameAsc"] = "name_ASC";
    RoleOrderByInput["NameDesc"] = "name_DESC";
    RoleOrderByInput["RoleTypeAsc"] = "roleType_ASC";
    RoleOrderByInput["RoleTypeDesc"] = "roleType_DESC";
    RoleOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    RoleOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    RoleOrderByInput["VisibleAsc"] = "visible_ASC";
    RoleOrderByInput["VisibleDesc"] = "visible_DESC";
})(RoleOrderByInput || (RoleOrderByInput = {}));
export var GlobalFilterOrderByInput;
(function (GlobalFilterOrderByInput) {
    GlobalFilterOrderByInput["AllEnabledAsc"] = "allEnabled_ASC";
    GlobalFilterOrderByInput["AllEnabledDesc"] = "allEnabled_DESC";
    GlobalFilterOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    GlobalFilterOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    GlobalFilterOrderByInput["IdAsc"] = "id_ASC";
    GlobalFilterOrderByInput["IdDesc"] = "id_DESC";
    GlobalFilterOrderByInput["TitleAsc"] = "title_ASC";
    GlobalFilterOrderByInput["TitleDesc"] = "title_DESC";
    GlobalFilterOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    GlobalFilterOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(GlobalFilterOrderByInput || (GlobalFilterOrderByInput = {}));
export var DataSourceLicenseOrderByInput;
(function (DataSourceLicenseOrderByInput) {
    DataSourceLicenseOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DataSourceLicenseOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DataSourceLicenseOrderByInput["EndDateAsc"] = "endDate_ASC";
    DataSourceLicenseOrderByInput["EndDateDesc"] = "endDate_DESC";
    DataSourceLicenseOrderByInput["IdAsc"] = "id_ASC";
    DataSourceLicenseOrderByInput["IdDesc"] = "id_DESC";
    DataSourceLicenseOrderByInput["IntervalAsc"] = "interval_ASC";
    DataSourceLicenseOrderByInput["IntervalDesc"] = "interval_DESC";
    DataSourceLicenseOrderByInput["RenewalDateAsc"] = "renewalDate_ASC";
    DataSourceLicenseOrderByInput["RenewalDateDesc"] = "renewalDate_DESC";
    DataSourceLicenseOrderByInput["StartDateAsc"] = "startDate_ASC";
    DataSourceLicenseOrderByInput["StartDateDesc"] = "startDate_DESC";
    DataSourceLicenseOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DataSourceLicenseOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DataSourceLicenseOrderByInput || (DataSourceLicenseOrderByInput = {}));
export var ModuleLicenseOrderByInput;
(function (ModuleLicenseOrderByInput) {
    ModuleLicenseOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ModuleLicenseOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ModuleLicenseOrderByInput["IdAsc"] = "id_ASC";
    ModuleLicenseOrderByInput["IdDesc"] = "id_DESC";
    ModuleLicenseOrderByInput["LevelAsc"] = "level_ASC";
    ModuleLicenseOrderByInput["LevelDesc"] = "level_DESC";
    ModuleLicenseOrderByInput["ModuleAsc"] = "module_ASC";
    ModuleLicenseOrderByInput["ModuleDesc"] = "module_DESC";
    ModuleLicenseOrderByInput["StatusAsc"] = "status_ASC";
    ModuleLicenseOrderByInput["StatusDesc"] = "status_DESC";
    ModuleLicenseOrderByInput["TitleAsc"] = "title_ASC";
    ModuleLicenseOrderByInput["TitleDesc"] = "title_DESC";
    ModuleLicenseOrderByInput["UniqueTitleAsc"] = "uniqueTitle_ASC";
    ModuleLicenseOrderByInput["UniqueTitleDesc"] = "uniqueTitle_DESC";
    ModuleLicenseOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ModuleLicenseOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ModuleLicenseOrderByInput || (ModuleLicenseOrderByInput = {}));
export var OrderDiscountOrderByInput;
(function (OrderDiscountOrderByInput) {
    OrderDiscountOrderByInput["AmountAsc"] = "amount_ASC";
    OrderDiscountOrderByInput["AmountDesc"] = "amount_DESC";
    OrderDiscountOrderByInput["CalculatedAmountAsc"] = "calculatedAmount_ASC";
    OrderDiscountOrderByInput["CalculatedAmountDesc"] = "calculatedAmount_DESC";
    OrderDiscountOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    OrderDiscountOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    OrderDiscountOrderByInput["DescriptionAsc"] = "description_ASC";
    OrderDiscountOrderByInput["DescriptionDesc"] = "description_DESC";
    OrderDiscountOrderByInput["IdAsc"] = "id_ASC";
    OrderDiscountOrderByInput["IdDesc"] = "id_DESC";
    OrderDiscountOrderByInput["TitleAsc"] = "title_ASC";
    OrderDiscountOrderByInput["TitleDesc"] = "title_DESC";
    OrderDiscountOrderByInput["TypeAsc"] = "type_ASC";
    OrderDiscountOrderByInput["TypeDesc"] = "type_DESC";
    OrderDiscountOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    OrderDiscountOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(OrderDiscountOrderByInput || (OrderDiscountOrderByInput = {}));
export var OrderItemOrderByInput;
(function (OrderItemOrderByInput) {
    OrderItemOrderByInput["AmountAsc"] = "amount_ASC";
    OrderItemOrderByInput["AmountDesc"] = "amount_DESC";
    OrderItemOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    OrderItemOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    OrderItemOrderByInput["DescriptionAsc"] = "description_ASC";
    OrderItemOrderByInput["DescriptionDesc"] = "description_DESC";
    OrderItemOrderByInput["DiscountAsc"] = "discount_ASC";
    OrderItemOrderByInput["DiscountDesc"] = "discount_DESC";
    OrderItemOrderByInput["DiscountTypeAsc"] = "discountType_ASC";
    OrderItemOrderByInput["DiscountTypeDesc"] = "discountType_DESC";
    OrderItemOrderByInput["EndDateAsc"] = "endDate_ASC";
    OrderItemOrderByInput["EndDateDesc"] = "endDate_DESC";
    OrderItemOrderByInput["IdAsc"] = "id_ASC";
    OrderItemOrderByInput["IdDesc"] = "id_DESC";
    OrderItemOrderByInput["LimitAsc"] = "limit_ASC";
    OrderItemOrderByInput["LimitDesc"] = "limit_DESC";
    OrderItemOrderByInput["PriceAsc"] = "price_ASC";
    OrderItemOrderByInput["PriceDesc"] = "price_DESC";
    OrderItemOrderByInput["QuantityAsc"] = "quantity_ASC";
    OrderItemOrderByInput["QuantityDesc"] = "quantity_DESC";
    OrderItemOrderByInput["RelationIdAsc"] = "relationId_ASC";
    OrderItemOrderByInput["RelationIdDesc"] = "relationId_DESC";
    OrderItemOrderByInput["StartDateAsc"] = "startDate_ASC";
    OrderItemOrderByInput["StartDateDesc"] = "startDate_DESC";
    OrderItemOrderByInput["TitleAsc"] = "title_ASC";
    OrderItemOrderByInput["TitleDesc"] = "title_DESC";
    OrderItemOrderByInput["TypeAsc"] = "type_ASC";
    OrderItemOrderByInput["TypeDesc"] = "type_DESC";
    OrderItemOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    OrderItemOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(OrderItemOrderByInput || (OrderItemOrderByInput = {}));
export var OrderOrderByInput;
(function (OrderOrderByInput) {
    OrderOrderByInput["AmountAsc"] = "amount_ASC";
    OrderOrderByInput["AmountDesc"] = "amount_DESC";
    OrderOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    OrderOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    OrderOrderByInput["CurrencyAsc"] = "currency_ASC";
    OrderOrderByInput["CurrencyDesc"] = "currency_DESC";
    OrderOrderByInput["DataSourceAsc"] = "dataSource_ASC";
    OrderOrderByInput["DataSourceDesc"] = "dataSource_DESC";
    OrderOrderByInput["DiscountAsc"] = "discount_ASC";
    OrderOrderByInput["DiscountDesc"] = "discount_DESC";
    OrderOrderByInput["DiscountTypeAsc"] = "discountType_ASC";
    OrderOrderByInput["DiscountTypeDesc"] = "discountType_DESC";
    OrderOrderByInput["EndDateAsc"] = "endDate_ASC";
    OrderOrderByInput["EndDateDesc"] = "endDate_DESC";
    OrderOrderByInput["IdAsc"] = "id_ASC";
    OrderOrderByInput["IdDesc"] = "id_DESC";
    OrderOrderByInput["MonthlyAmountAsc"] = "monthlyAmount_ASC";
    OrderOrderByInput["MonthlyAmountDesc"] = "monthlyAmount_DESC";
    OrderOrderByInput["OrderNumberAsc"] = "orderNumber_ASC";
    OrderOrderByInput["OrderNumberDesc"] = "orderNumber_DESC";
    OrderOrderByInput["PaymentDateAsc"] = "paymentDate_ASC";
    OrderOrderByInput["PaymentDateDesc"] = "paymentDate_DESC";
    OrderOrderByInput["PaymentStatusAsc"] = "paymentStatus_ASC";
    OrderOrderByInput["PaymentStatusDesc"] = "paymentStatus_DESC";
    OrderOrderByInput["PaymentTypeAsc"] = "paymentType_ASC";
    OrderOrderByInput["PaymentTypeDesc"] = "paymentType_DESC";
    OrderOrderByInput["PipedriveNoteIdAsc"] = "pipedriveNoteId_ASC";
    OrderOrderByInput["PipedriveNoteIdDesc"] = "pipedriveNoteId_DESC";
    OrderOrderByInput["StartDateAsc"] = "startDate_ASC";
    OrderOrderByInput["StartDateDesc"] = "startDate_DESC";
    OrderOrderByInput["StripeInvoiceIdAsc"] = "stripeInvoiceId_ASC";
    OrderOrderByInput["StripeInvoiceIdDesc"] = "stripeInvoiceId_DESC";
    OrderOrderByInput["StripePaymentIntentIdAsc"] = "stripePaymentIntentId_ASC";
    OrderOrderByInput["StripePaymentIntentIdDesc"] = "stripePaymentIntentId_DESC";
    OrderOrderByInput["SubtotalAsc"] = "subtotal_ASC";
    OrderOrderByInput["SubtotalDesc"] = "subtotal_DESC";
    OrderOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    OrderOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(OrderOrderByInput || (OrderOrderByInput = {}));
export var DataSourceLicensePeriodOrderByInput;
(function (DataSourceLicensePeriodOrderByInput) {
    DataSourceLicensePeriodOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DataSourceLicensePeriodOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DataSourceLicensePeriodOrderByInput["EndDateAsc"] = "endDate_ASC";
    DataSourceLicensePeriodOrderByInput["EndDateDesc"] = "endDate_DESC";
    DataSourceLicensePeriodOrderByInput["IdAsc"] = "id_ASC";
    DataSourceLicensePeriodOrderByInput["IdDesc"] = "id_DESC";
    DataSourceLicensePeriodOrderByInput["StartDateAsc"] = "startDate_ASC";
    DataSourceLicensePeriodOrderByInput["StartDateDesc"] = "startDate_DESC";
    DataSourceLicensePeriodOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DataSourceLicensePeriodOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DataSourceLicensePeriodOrderByInput || (DataSourceLicensePeriodOrderByInput = {}));
export var PeriodUsageOrderByInput;
(function (PeriodUsageOrderByInput) {
    PeriodUsageOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    PeriodUsageOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    PeriodUsageOrderByInput["CurrentAsc"] = "current_ASC";
    PeriodUsageOrderByInput["CurrentDesc"] = "current_DESC";
    PeriodUsageOrderByInput["EstimatedAsc"] = "estimated_ASC";
    PeriodUsageOrderByInput["EstimatedDesc"] = "estimated_DESC";
    PeriodUsageOrderByInput["IdAsc"] = "id_ASC";
    PeriodUsageOrderByInput["IdDesc"] = "id_DESC";
    PeriodUsageOrderByInput["KeyAsc"] = "key_ASC";
    PeriodUsageOrderByInput["KeyDesc"] = "key_DESC";
    PeriodUsageOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    PeriodUsageOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(PeriodUsageOrderByInput || (PeriodUsageOrderByInput = {}));
export var SurveyLanguageGroupOrderByInput;
(function (SurveyLanguageGroupOrderByInput) {
    SurveyLanguageGroupOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveyLanguageGroupOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveyLanguageGroupOrderByInput["IdAsc"] = "id_ASC";
    SurveyLanguageGroupOrderByInput["IdDesc"] = "id_DESC";
    SurveyLanguageGroupOrderByInput["TitleAsc"] = "title_ASC";
    SurveyLanguageGroupOrderByInput["TitleDesc"] = "title_DESC";
    SurveyLanguageGroupOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveyLanguageGroupOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(SurveyLanguageGroupOrderByInput || (SurveyLanguageGroupOrderByInput = {}));
export var SurveyOrderByInput;
(function (SurveyOrderByInput) {
    SurveyOrderByInput["AllowPersonalDataAsc"] = "allowPersonalData_ASC";
    SurveyOrderByInput["AllowPersonalDataDesc"] = "allowPersonalData_DESC";
    SurveyOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveyOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveyOrderByInput["CustomerAliasAsc"] = "customerAlias_ASC";
    SurveyOrderByInput["CustomerAliasDesc"] = "customerAlias_DESC";
    SurveyOrderByInput["IdAsc"] = "id_ASC";
    SurveyOrderByInput["IdDesc"] = "id_DESC";
    SurveyOrderByInput["LanguageAsc"] = "language_ASC";
    SurveyOrderByInput["LanguageDesc"] = "language_DESC";
    SurveyOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    SurveyOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    SurveyOrderByInput["PrimaryAsc"] = "primary_ASC";
    SurveyOrderByInput["PrimaryDesc"] = "primary_DESC";
    SurveyOrderByInput["TitleAsc"] = "title_ASC";
    SurveyOrderByInput["TitleDesc"] = "title_DESC";
    SurveyOrderByInput["TypeAsc"] = "type_ASC";
    SurveyOrderByInput["TypeDesc"] = "type_DESC";
    SurveyOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveyOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    SurveyOrderByInput["VersionAsc"] = "version_ASC";
    SurveyOrderByInput["VersionDesc"] = "version_DESC";
})(SurveyOrderByInput || (SurveyOrderByInput = {}));
export var SurveyCategoryOrderByInput;
(function (SurveyCategoryOrderByInput) {
    SurveyCategoryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveyCategoryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveyCategoryOrderByInput["IdAsc"] = "id_ASC";
    SurveyCategoryOrderByInput["IdDesc"] = "id_DESC";
    SurveyCategoryOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    SurveyCategoryOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    SurveyCategoryOrderByInput["TitleAsc"] = "title_ASC";
    SurveyCategoryOrderByInput["TitleDesc"] = "title_DESC";
    SurveyCategoryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveyCategoryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(SurveyCategoryOrderByInput || (SurveyCategoryOrderByInput = {}));
export var BenchmarkSegmentOrderByInput;
(function (BenchmarkSegmentOrderByInput) {
    BenchmarkSegmentOrderByInput["ColorAsc"] = "color_ASC";
    BenchmarkSegmentOrderByInput["ColorDesc"] = "color_DESC";
    BenchmarkSegmentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    BenchmarkSegmentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    BenchmarkSegmentOrderByInput["IdAsc"] = "id_ASC";
    BenchmarkSegmentOrderByInput["IdDesc"] = "id_DESC";
    BenchmarkSegmentOrderByInput["IsEnabledAsc"] = "isEnabled_ASC";
    BenchmarkSegmentOrderByInput["IsEnabledDesc"] = "isEnabled_DESC";
    BenchmarkSegmentOrderByInput["SortIndexAsc"] = "sortIndex_ASC";
    BenchmarkSegmentOrderByInput["SortIndexDesc"] = "sortIndex_DESC";
    BenchmarkSegmentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    BenchmarkSegmentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(BenchmarkSegmentOrderByInput || (BenchmarkSegmentOrderByInput = {}));
export var GlobalFilterSegmentOrderByInput;
(function (GlobalFilterSegmentOrderByInput) {
    GlobalFilterSegmentOrderByInput["ColorAsc"] = "color_ASC";
    GlobalFilterSegmentOrderByInput["ColorDesc"] = "color_DESC";
    GlobalFilterSegmentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    GlobalFilterSegmentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    GlobalFilterSegmentOrderByInput["EnabledAsc"] = "enabled_ASC";
    GlobalFilterSegmentOrderByInput["EnabledDesc"] = "enabled_DESC";
    GlobalFilterSegmentOrderByInput["IdAsc"] = "id_ASC";
    GlobalFilterSegmentOrderByInput["IdDesc"] = "id_DESC";
    GlobalFilterSegmentOrderByInput["QueryAsc"] = "query_ASC";
    GlobalFilterSegmentOrderByInput["QueryDesc"] = "query_DESC";
    GlobalFilterSegmentOrderByInput["SortIndexAsc"] = "sortIndex_ASC";
    GlobalFilterSegmentOrderByInput["SortIndexDesc"] = "sortIndex_DESC";
    GlobalFilterSegmentOrderByInput["TitleAsc"] = "title_ASC";
    GlobalFilterSegmentOrderByInput["TitleDesc"] = "title_DESC";
    GlobalFilterSegmentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    GlobalFilterSegmentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(GlobalFilterSegmentOrderByInput || (GlobalFilterSegmentOrderByInput = {}));
export var ReportContentOrderByInput;
(function (ReportContentOrderByInput) {
    ReportContentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ReportContentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ReportContentOrderByInput["IdAsc"] = "id_ASC";
    ReportContentOrderByInput["IdDesc"] = "id_DESC";
    ReportContentOrderByInput["SortOrderAsc"] = "sortOrder_ASC";
    ReportContentOrderByInput["SortOrderDesc"] = "sortOrder_DESC";
    ReportContentOrderByInput["TitleAsc"] = "title_ASC";
    ReportContentOrderByInput["TitleDesc"] = "title_DESC";
    ReportContentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ReportContentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ReportContentOrderByInput || (ReportContentOrderByInput = {}));
export var FunnelStepOrderByInput;
(function (FunnelStepOrderByInput) {
    FunnelStepOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FunnelStepOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FunnelStepOrderByInput["IdAsc"] = "id_ASC";
    FunnelStepOrderByInput["IdDesc"] = "id_DESC";
    FunnelStepOrderByInput["SortIndexAsc"] = "sortIndex_ASC";
    FunnelStepOrderByInput["SortIndexDesc"] = "sortIndex_DESC";
    FunnelStepOrderByInput["TitleAsc"] = "title_ASC";
    FunnelStepOrderByInput["TitleDesc"] = "title_DESC";
    FunnelStepOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FunnelStepOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FunnelStepOrderByInput || (FunnelStepOrderByInput = {}));
export var AccessibilityReviewScopeOrderByInput;
(function (AccessibilityReviewScopeOrderByInput) {
    AccessibilityReviewScopeOrderByInput["ActiveAsc"] = "active_ASC";
    AccessibilityReviewScopeOrderByInput["ActiveDesc"] = "active_DESC";
    AccessibilityReviewScopeOrderByInput["AutomaticRunsEnabledAsc"] = "automaticRunsEnabled_ASC";
    AccessibilityReviewScopeOrderByInput["AutomaticRunsEnabledDesc"] = "automaticRunsEnabled_DESC";
    AccessibilityReviewScopeOrderByInput["BaselineIdAsc"] = "baselineId_ASC";
    AccessibilityReviewScopeOrderByInput["BaselineIdDesc"] = "baselineId_DESC";
    AccessibilityReviewScopeOrderByInput["BaselineVersionAsc"] = "baselineVersion_ASC";
    AccessibilityReviewScopeOrderByInput["BaselineVersionDesc"] = "baselineVersion_DESC";
    AccessibilityReviewScopeOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityReviewScopeOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityReviewScopeOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityReviewScopeOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityReviewScopeOrderByInput["PdfScanningEnabledAsc"] = "pdfScanningEnabled_ASC";
    AccessibilityReviewScopeOrderByInput["PdfScanningEnabledDesc"] = "pdfScanningEnabled_DESC";
    AccessibilityReviewScopeOrderByInput["PdfScanningUpdatedAtAsc"] = "pdfScanningUpdatedAt_ASC";
    AccessibilityReviewScopeOrderByInput["PdfScanningUpdatedAtDesc"] = "pdfScanningUpdatedAt_DESC";
    AccessibilityReviewScopeOrderByInput["PdfScanningUpdatedByAsc"] = "pdfScanningUpdatedBy_ASC";
    AccessibilityReviewScopeOrderByInput["PdfScanningUpdatedByDesc"] = "pdfScanningUpdatedBy_DESC";
    AccessibilityReviewScopeOrderByInput["ProviderAsc"] = "provider_ASC";
    AccessibilityReviewScopeOrderByInput["ProviderDesc"] = "provider_DESC";
    AccessibilityReviewScopeOrderByInput["ProviderSiteIdAsc"] = "providerSiteId_ASC";
    AccessibilityReviewScopeOrderByInput["ProviderSiteIdDesc"] = "providerSiteId_DESC";
    AccessibilityReviewScopeOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityReviewScopeOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AccessibilityReviewScopeOrderByInput["UrlScopeMetadataKeyAsc"] = "urlScopeMetadataKey_ASC";
    AccessibilityReviewScopeOrderByInput["UrlScopeMetadataKeyDesc"] = "urlScopeMetadataKey_DESC";
})(AccessibilityReviewScopeOrderByInput || (AccessibilityReviewScopeOrderByInput = {}));
export var WebsiteLanguageOrderByInput;
(function (WebsiteLanguageOrderByInput) {
    WebsiteLanguageOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebsiteLanguageOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebsiteLanguageOrderByInput["IdAsc"] = "id_ASC";
    WebsiteLanguageOrderByInput["IdDesc"] = "id_DESC";
    WebsiteLanguageOrderByInput["LanguageAsc"] = "language_ASC";
    WebsiteLanguageOrderByInput["LanguageDesc"] = "language_DESC";
    WebsiteLanguageOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebsiteLanguageOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    WebsiteLanguageOrderByInput["UrlAsc"] = "url_ASC";
    WebsiteLanguageOrderByInput["UrlDesc"] = "url_DESC";
})(WebsiteLanguageOrderByInput || (WebsiteLanguageOrderByInput = {}));
export var WebsiteCheckOrderByInput;
(function (WebsiteCheckOrderByInput) {
    WebsiteCheckOrderByInput["CheckedPageCountAsc"] = "checkedPageCount_ASC";
    WebsiteCheckOrderByInput["CheckedPageCountDesc"] = "checkedPageCount_DESC";
    WebsiteCheckOrderByInput["CrawlStopReasonAsc"] = "crawlStopReason_ASC";
    WebsiteCheckOrderByInput["CrawlStopReasonDesc"] = "crawlStopReason_DESC";
    WebsiteCheckOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebsiteCheckOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebsiteCheckOrderByInput["EntryUrlAsc"] = "entryUrl_ASC";
    WebsiteCheckOrderByInput["EntryUrlDesc"] = "entryUrl_DESC";
    WebsiteCheckOrderByInput["IdAsc"] = "id_ASC";
    WebsiteCheckOrderByInput["IdDesc"] = "id_DESC";
    WebsiteCheckOrderByInput["LastProgressAtAsc"] = "lastProgressAt_ASC";
    WebsiteCheckOrderByInput["LastProgressAtDesc"] = "lastProgressAt_DESC";
    WebsiteCheckOrderByInput["PurposeAsc"] = "purpose_ASC";
    WebsiteCheckOrderByInput["PurposeDesc"] = "purpose_DESC";
    WebsiteCheckOrderByInput["RecursiveAsc"] = "recursive_ASC";
    WebsiteCheckOrderByInput["RecursiveDesc"] = "recursive_DESC";
    WebsiteCheckOrderByInput["StatusAsc"] = "status_ASC";
    WebsiteCheckOrderByInput["StatusDesc"] = "status_DESC";
    WebsiteCheckOrderByInput["TypeAsc"] = "type_ASC";
    WebsiteCheckOrderByInput["TypeDesc"] = "type_DESC";
    WebsiteCheckOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebsiteCheckOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(WebsiteCheckOrderByInput || (WebsiteCheckOrderByInput = {}));
export var WebDistributionOrderByInput;
(function (WebDistributionOrderByInput) {
    WebDistributionOrderByInput["AnswerLaterTriggerAsc"] = "answerLaterTrigger_ASC";
    WebDistributionOrderByInput["AnswerLaterTriggerDesc"] = "answerLaterTrigger_DESC";
    WebDistributionOrderByInput["BehaviorSettingAsc"] = "behaviorSetting_ASC";
    WebDistributionOrderByInput["BehaviorSettingDesc"] = "behaviorSetting_DESC";
    WebDistributionOrderByInput["ButtonIconAsc"] = "buttonIcon_ASC";
    WebDistributionOrderByInput["ButtonIconDesc"] = "buttonIcon_DESC";
    WebDistributionOrderByInput["ButtonLabelAsc"] = "buttonLabel_ASC";
    WebDistributionOrderByInput["ButtonLabelDesc"] = "buttonLabel_DESC";
    WebDistributionOrderByInput["ContainerAsc"] = "container_ASC";
    WebDistributionOrderByInput["ContainerDesc"] = "container_DESC";
    WebDistributionOrderByInput["ContainerTypeAsc"] = "containerType_ASC";
    WebDistributionOrderByInput["ContainerTypeDesc"] = "containerType_DESC";
    WebDistributionOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebDistributionOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebDistributionOrderByInput["CustomExpressionAsc"] = "customExpression_ASC";
    WebDistributionOrderByInput["CustomExpressionDesc"] = "customExpression_DESC";
    WebDistributionOrderByInput["DeclineFrequencyAsc"] = "declineFrequency_ASC";
    WebDistributionOrderByInput["DeclineFrequencyDesc"] = "declineFrequency_DESC";
    WebDistributionOrderByInput["DelayAsc"] = "delay_ASC";
    WebDistributionOrderByInput["DelayDesc"] = "delay_DESC";
    WebDistributionOrderByInput["DesignSettingAsc"] = "designSetting_ASC";
    WebDistributionOrderByInput["DesignSettingDesc"] = "designSetting_DESC";
    WebDistributionOrderByInput["ElementSelectorAsc"] = "elementSelector_ASC";
    WebDistributionOrderByInput["ElementSelectorDesc"] = "elementSelector_DESC";
    WebDistributionOrderByInput["EmbedPositionAsc"] = "embedPosition_ASC";
    WebDistributionOrderByInput["EmbedPositionDesc"] = "embedPosition_DESC";
    WebDistributionOrderByInput["EndDateAsc"] = "endDate_ASC";
    WebDistributionOrderByInput["EndDateDesc"] = "endDate_DESC";
    WebDistributionOrderByInput["FrequencyAsc"] = "frequency_ASC";
    WebDistributionOrderByInput["FrequencyDesc"] = "frequency_DESC";
    WebDistributionOrderByInput["IdAsc"] = "id_ASC";
    WebDistributionOrderByInput["IdDesc"] = "id_DESC";
    WebDistributionOrderByInput["IdleAsc"] = "idle_ASC";
    WebDistributionOrderByInput["IdleDesc"] = "idle_DESC";
    WebDistributionOrderByInput["IframeAsc"] = "iframe_ASC";
    WebDistributionOrderByInput["IframeDesc"] = "iframe_DESC";
    WebDistributionOrderByInput["LegacySurveyUrlAsc"] = "legacySurveyUrl_ASC";
    WebDistributionOrderByInput["LegacySurveyUrlDesc"] = "legacySurveyUrl_DESC";
    WebDistributionOrderByInput["LogoHeightAsc"] = "logoHeight_ASC";
    WebDistributionOrderByInput["LogoHeightDesc"] = "logoHeight_DESC";
    WebDistributionOrderByInput["LogoSourceAsc"] = "logoSource_ASC";
    WebDistributionOrderByInput["LogoSourceDesc"] = "logoSource_DESC";
    WebDistributionOrderByInput["LogoUrlAsc"] = "logoUrl_ASC";
    WebDistributionOrderByInput["LogoUrlDesc"] = "logoUrl_DESC";
    WebDistributionOrderByInput["PopupHeightAsc"] = "popupHeight_ASC";
    WebDistributionOrderByInput["PopupHeightDesc"] = "popupHeight_DESC";
    WebDistributionOrderByInput["PopupWidthAsc"] = "popupWidth_ASC";
    WebDistributionOrderByInput["PopupWidthDesc"] = "popupWidth_DESC";
    WebDistributionOrderByInput["PortionAsc"] = "portion_ASC";
    WebDistributionOrderByInput["PortionDesc"] = "portion_DESC";
    WebDistributionOrderByInput["QuizModeAsc"] = "quizMode_ASC";
    WebDistributionOrderByInput["QuizModeDesc"] = "quizMode_DESC";
    WebDistributionOrderByInput["SessionDelayAsc"] = "sessionDelay_ASC";
    WebDistributionOrderByInput["SessionDelayDesc"] = "sessionDelay_DESC";
    WebDistributionOrderByInput["ShowProgressAsc"] = "showProgress_ASC";
    WebDistributionOrderByInput["ShowProgressDesc"] = "showProgress_DESC";
    WebDistributionOrderByInput["StartDateAsc"] = "startDate_ASC";
    WebDistributionOrderByInput["StartDateDesc"] = "startDate_DESC";
    WebDistributionOrderByInput["ThemeAsc"] = "theme_ASC";
    WebDistributionOrderByInput["ThemeDesc"] = "theme_DESC";
    WebDistributionOrderByInput["TriggerAsc"] = "trigger_ASC";
    WebDistributionOrderByInput["TriggerDesc"] = "trigger_DESC";
    WebDistributionOrderByInput["TriggerPositionAsc"] = "triggerPosition_ASC";
    WebDistributionOrderByInput["TriggerPositionDesc"] = "triggerPosition_DESC";
    WebDistributionOrderByInput["TriggerStyleAsc"] = "triggerStyle_ASC";
    WebDistributionOrderByInput["TriggerStyleDesc"] = "triggerStyle_DESC";
    WebDistributionOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebDistributionOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    WebDistributionOrderByInput["UseToggleButtonsAsc"] = "useToggleButtons_ASC";
    WebDistributionOrderByInput["UseToggleButtonsDesc"] = "useToggleButtons_DESC";
    WebDistributionOrderByInput["WebsiteLanguageIdAsc"] = "websiteLanguageId_ASC";
    WebDistributionOrderByInput["WebsiteLanguageIdDesc"] = "websiteLanguageId_DESC";
})(WebDistributionOrderByInput || (WebDistributionOrderByInput = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "DESKTOP";
    DeviceType["Mobile"] = "MOBILE";
    DeviceType["Tablet"] = "TABLET";
})(DeviceType || (DeviceType = {}));
export var ScriptOrderByInput;
(function (ScriptOrderByInput) {
    ScriptOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ScriptOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ScriptOrderByInput["IdAsc"] = "id_ASC";
    ScriptOrderByInput["IdDesc"] = "id_DESC";
    ScriptOrderByInput["KeyAsc"] = "key_ASC";
    ScriptOrderByInput["KeyDesc"] = "key_DESC";
    ScriptOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ScriptOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ScriptOrderByInput || (ScriptOrderByInput = {}));
export var WebsiteOrderByInput;
(function (WebsiteOrderByInput) {
    WebsiteOrderByInput["BrokenLinksEnabledAsc"] = "brokenLinksEnabled_ASC";
    WebsiteOrderByInput["BrokenLinksEnabledDesc"] = "brokenLinksEnabled_DESC";
    WebsiteOrderByInput["CheckIntervalAsc"] = "checkInterval_ASC";
    WebsiteOrderByInput["CheckIntervalDesc"] = "checkInterval_DESC";
    WebsiteOrderByInput["CheckReportEmailAsc"] = "checkReportEmail_ASC";
    WebsiteOrderByInput["CheckReportEmailDesc"] = "checkReportEmail_DESC";
    WebsiteOrderByInput["CheckReportSentAtAsc"] = "checkReportSentAt_ASC";
    WebsiteOrderByInput["CheckReportSentAtDesc"] = "checkReportSentAt_DESC";
    WebsiteOrderByInput["CookiePrefixAsc"] = "cookiePrefix_ASC";
    WebsiteOrderByInput["CookiePrefixDesc"] = "cookiePrefix_DESC";
    WebsiteOrderByInput["CrashAnalyticsAsc"] = "crashAnalytics_ASC";
    WebsiteOrderByInput["CrashAnalyticsDesc"] = "crashAnalytics_DESC";
    WebsiteOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WebsiteOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WebsiteOrderByInput["CustomCssAsc"] = "customCSS_ASC";
    WebsiteOrderByInput["CustomCssDesc"] = "customCSS_DESC";
    WebsiteOrderByInput["DisableCookiesAsc"] = "disableCookies_ASC";
    WebsiteOrderByInput["DisableCookiesDesc"] = "disableCookies_DESC";
    WebsiteOrderByInput["FormAnalyticsAsc"] = "formAnalytics_ASC";
    WebsiteOrderByInput["FormAnalyticsDesc"] = "formAnalytics_DESC";
    WebsiteOrderByInput["Ga4PropertyIdAsc"] = "ga4PropertyId_ASC";
    WebsiteOrderByInput["Ga4PropertyIdDesc"] = "ga4PropertyId_DESC";
    WebsiteOrderByInput["IdAsc"] = "id_ASC";
    WebsiteOrderByInput["IdDesc"] = "id_DESC";
    WebsiteOrderByInput["LanguageAsc"] = "language_ASC";
    WebsiteOrderByInput["LanguageDesc"] = "language_DESC";
    WebsiteOrderByInput["LastActivityTimestampAsc"] = "lastActivityTimestamp_ASC";
    WebsiteOrderByInput["LastActivityTimestampDesc"] = "lastActivityTimestamp_DESC";
    WebsiteOrderByInput["LastActivityUrlAsc"] = "lastActivityUrl_ASC";
    WebsiteOrderByInput["LastActivityUrlDesc"] = "lastActivityUrl_DESC";
    WebsiteOrderByInput["LinkTrackingAsc"] = "linkTracking_ASC";
    WebsiteOrderByInput["LinkTrackingDesc"] = "linkTracking_DESC";
    WebsiteOrderByInput["MatomoIdAsc"] = "matomoId_ASC";
    WebsiteOrderByInput["MatomoIdDesc"] = "matomoId_DESC";
    WebsiteOrderByInput["MediaAnalyticsAsc"] = "mediaAnalytics_ASC";
    WebsiteOrderByInput["MediaAnalyticsDesc"] = "mediaAnalytics_DESC";
    WebsiteOrderByInput["RequireCookieConsentAsc"] = "requireCookieConsent_ASC";
    WebsiteOrderByInput["RequireCookieConsentDesc"] = "requireCookieConsent_DESC";
    WebsiteOrderByInput["TitleAsc"] = "title_ASC";
    WebsiteOrderByInput["TitleDesc"] = "title_DESC";
    WebsiteOrderByInput["TrackPageViewsAsc"] = "trackPageViews_ASC";
    WebsiteOrderByInput["TrackPageViewsDesc"] = "trackPageViews_DESC";
    WebsiteOrderByInput["TrackVisitorsAsc"] = "trackVisitors_ASC";
    WebsiteOrderByInput["TrackVisitorsDesc"] = "trackVisitors_DESC";
    WebsiteOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WebsiteOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    WebsiteOrderByInput["UrlAsc"] = "url_ASC";
    WebsiteOrderByInput["UrlDesc"] = "url_DESC";
    WebsiteOrderByInput["UseCookiesAsc"] = "useCookies_ASC";
    WebsiteOrderByInput["UseCookiesDesc"] = "useCookies_DESC";
})(WebsiteOrderByInput || (WebsiteOrderByInput = {}));
export var FilterOrderByInput;
(function (FilterOrderByInput) {
    FilterOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FilterOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FilterOrderByInput["DisplayedSurveyIdAsc"] = "displayedSurveyId_ASC";
    FilterOrderByInput["DisplayedSurveyIdDesc"] = "displayedSurveyId_DESC";
    FilterOrderByInput["IdAsc"] = "id_ASC";
    FilterOrderByInput["IdDesc"] = "id_DESC";
    FilterOrderByInput["SurveyGroupIdAsc"] = "surveyGroupId_ASC";
    FilterOrderByInput["SurveyGroupIdDesc"] = "surveyGroupId_DESC";
    FilterOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FilterOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FilterOrderByInput || (FilterOrderByInput = {}));
export var FilterSegmentOrderByInput;
(function (FilterSegmentOrderByInput) {
    FilterSegmentOrderByInput["ColorAsc"] = "color_ASC";
    FilterSegmentOrderByInput["ColorDesc"] = "color_DESC";
    FilterSegmentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FilterSegmentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FilterSegmentOrderByInput["CreatedByEmailAsc"] = "createdByEmail_ASC";
    FilterSegmentOrderByInput["CreatedByEmailDesc"] = "createdByEmail_DESC";
    FilterSegmentOrderByInput["FilterOptionsInvertedAsc"] = "filterOptionsInverted_ASC";
    FilterSegmentOrderByInput["FilterOptionsInvertedDesc"] = "filterOptionsInverted_DESC";
    FilterSegmentOrderByInput["FilterOptionsOperatorAsc"] = "filterOptionsOperator_ASC";
    FilterSegmentOrderByInput["FilterOptionsOperatorDesc"] = "filterOptionsOperator_DESC";
    FilterSegmentOrderByInput["FriendlyTitleAsc"] = "friendlyTitle_ASC";
    FilterSegmentOrderByInput["FriendlyTitleDesc"] = "friendlyTitle_DESC";
    FilterSegmentOrderByInput["IdAsc"] = "id_ASC";
    FilterSegmentOrderByInput["IdDesc"] = "id_DESC";
    FilterSegmentOrderByInput["IsEnabledAsc"] = "isEnabled_ASC";
    FilterSegmentOrderByInput["IsEnabledDesc"] = "isEnabled_DESC";
    FilterSegmentOrderByInput["MatomoCustomDimensionAsc"] = "matomoCustomDimension_ASC";
    FilterSegmentOrderByInput["MatomoCustomDimensionDesc"] = "matomoCustomDimension_DESC";
    FilterSegmentOrderByInput["SharedAsc"] = "shared_ASC";
    FilterSegmentOrderByInput["SharedDesc"] = "shared_DESC";
    FilterSegmentOrderByInput["SortIndexAsc"] = "sortIndex_ASC";
    FilterSegmentOrderByInput["SortIndexDesc"] = "sortIndex_DESC";
    FilterSegmentOrderByInput["SyncToMatomoAsc"] = "syncToMatomo_ASC";
    FilterSegmentOrderByInput["SyncToMatomoDesc"] = "syncToMatomo_DESC";
    FilterSegmentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FilterSegmentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FilterSegmentOrderByInput || (FilterSegmentOrderByInput = {}));
export var FilterOptionOrderByInput;
(function (FilterOptionOrderByInput) {
    FilterOptionOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FilterOptionOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FilterOptionOrderByInput["FriendlyTitleAsc"] = "friendlyTitle_ASC";
    FilterOptionOrderByInput["FriendlyTitleDesc"] = "friendlyTitle_DESC";
    FilterOptionOrderByInput["IdAsc"] = "id_ASC";
    FilterOptionOrderByInput["IdDesc"] = "id_DESC";
    FilterOptionOrderByInput["RelationIdAsc"] = "relationId_ASC";
    FilterOptionOrderByInput["RelationIdDesc"] = "relationId_DESC";
    FilterOptionOrderByInput["TypeAsc"] = "type_ASC";
    FilterOptionOrderByInput["TypeDesc"] = "type_DESC";
    FilterOptionOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FilterOptionOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FilterOptionOrderByInput || (FilterOptionOrderByInput = {}));
export var SharedFilterSegmentOrderByInput;
(function (SharedFilterSegmentOrderByInput) {
    SharedFilterSegmentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SharedFilterSegmentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SharedFilterSegmentOrderByInput["IdAsc"] = "id_ASC";
    SharedFilterSegmentOrderByInput["IdDesc"] = "id_DESC";
    SharedFilterSegmentOrderByInput["IsEnabledAsc"] = "isEnabled_ASC";
    SharedFilterSegmentOrderByInput["IsEnabledDesc"] = "isEnabled_DESC";
    SharedFilterSegmentOrderByInput["SortIndexAsc"] = "sortIndex_ASC";
    SharedFilterSegmentOrderByInput["SortIndexDesc"] = "sortIndex_DESC";
    SharedFilterSegmentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SharedFilterSegmentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(SharedFilterSegmentOrderByInput || (SharedFilterSegmentOrderByInput = {}));
export var SurveyResponseOrderByInput;
(function (SurveyResponseOrderByInput) {
    SurveyResponseOrderByInput["CompletedAsc"] = "completed_ASC";
    SurveyResponseOrderByInput["CompletedDesc"] = "completed_DESC";
    SurveyResponseOrderByInput["CountryCodeAsc"] = "countryCode_ASC";
    SurveyResponseOrderByInput["CountryCodeDesc"] = "countryCode_DESC";
    SurveyResponseOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveyResponseOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveyResponseOrderByInput["DistributionIdAsc"] = "distributionId_ASC";
    SurveyResponseOrderByInput["DistributionIdDesc"] = "distributionId_DESC";
    SurveyResponseOrderByInput["GaClientIdAsc"] = "gaClientId_ASC";
    SurveyResponseOrderByInput["GaClientIdDesc"] = "gaClientId_DESC";
    SurveyResponseOrderByInput["IdAsc"] = "id_ASC";
    SurveyResponseOrderByInput["IdDesc"] = "id_DESC";
    SurveyResponseOrderByInput["LanguageAsc"] = "language_ASC";
    SurveyResponseOrderByInput["LanguageDesc"] = "language_DESC";
    SurveyResponseOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    SurveyResponseOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    SurveyResponseOrderByInput["MatomoVisitIdAsc"] = "matomoVisitId_ASC";
    SurveyResponseOrderByInput["MatomoVisitIdDesc"] = "matomoVisitId_DESC";
    SurveyResponseOrderByInput["RespondedAtAsc"] = "respondedAt_ASC";
    SurveyResponseOrderByInput["RespondedAtDesc"] = "respondedAt_DESC";
    SurveyResponseOrderByInput["RespondentIdAsc"] = "respondentId_ASC";
    SurveyResponseOrderByInput["RespondentIdDesc"] = "respondentId_DESC";
    SurveyResponseOrderByInput["SurveyVisitIdAsc"] = "surveyVisitId_ASC";
    SurveyResponseOrderByInput["SurveyVisitIdDesc"] = "surveyVisitId_DESC";
    SurveyResponseOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveyResponseOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    SurveyResponseOrderByInput["UserAgentAsc"] = "userAgent_ASC";
    SurveyResponseOrderByInput["UserAgentDesc"] = "userAgent_DESC";
    SurveyResponseOrderByInput["WebpageTitleAsc"] = "webpageTitle_ASC";
    SurveyResponseOrderByInput["WebpageTitleDesc"] = "webpageTitle_DESC";
    SurveyResponseOrderByInput["WebpageUrlAsc"] = "webpageUrl_ASC";
    SurveyResponseOrderByInput["WebpageUrlDesc"] = "webpageUrl_DESC";
})(SurveyResponseOrderByInput || (SurveyResponseOrderByInput = {}));
export var QuestionResponseOrderByInput;
(function (QuestionResponseOrderByInput) {
    QuestionResponseOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    QuestionResponseOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    QuestionResponseOrderByInput["IdAsc"] = "id_ASC";
    QuestionResponseOrderByInput["IdDesc"] = "id_DESC";
    QuestionResponseOrderByInput["RedactedAtAsc"] = "redactedAt_ASC";
    QuestionResponseOrderByInput["RedactedAtDesc"] = "redactedAt_DESC";
    QuestionResponseOrderByInput["TextAsc"] = "text_ASC";
    QuestionResponseOrderByInput["TextDesc"] = "text_DESC";
    QuestionResponseOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    QuestionResponseOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    QuestionResponseOrderByInput["ValueAsc"] = "value_ASC";
    QuestionResponseOrderByInput["ValueDesc"] = "value_DESC";
})(QuestionResponseOrderByInput || (QuestionResponseOrderByInput = {}));
export var AutoTaggedCommentOrderByInput;
(function (AutoTaggedCommentOrderByInput) {
    AutoTaggedCommentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AutoTaggedCommentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AutoTaggedCommentOrderByInput["IdAsc"] = "id_ASC";
    AutoTaggedCommentOrderByInput["IdDesc"] = "id_DESC";
    AutoTaggedCommentOrderByInput["TranslationAsc"] = "translation_ASC";
    AutoTaggedCommentOrderByInput["TranslationDesc"] = "translation_DESC";
    AutoTaggedCommentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AutoTaggedCommentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AutoTaggedCommentOrderByInput || (AutoTaggedCommentOrderByInput = {}));
export var AutoTaggingOrderByInput;
(function (AutoTaggingOrderByInput) {
    AutoTaggingOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AutoTaggingOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AutoTaggingOrderByInput["IdAsc"] = "id_ASC";
    AutoTaggingOrderByInput["IdDesc"] = "id_DESC";
    AutoTaggingOrderByInput["InputAsc"] = "input_ASC";
    AutoTaggingOrderByInput["InputDesc"] = "input_DESC";
    AutoTaggingOrderByInput["PromptAsc"] = "prompt_ASC";
    AutoTaggingOrderByInput["PromptDesc"] = "prompt_DESC";
    AutoTaggingOrderByInput["ResponseAsc"] = "response_ASC";
    AutoTaggingOrderByInput["ResponseDesc"] = "response_DESC";
    AutoTaggingOrderByInput["StatusAsc"] = "status_ASC";
    AutoTaggingOrderByInput["StatusDesc"] = "status_DESC";
    AutoTaggingOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AutoTaggingOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AutoTaggingOrderByInput || (AutoTaggingOrderByInput = {}));
export var QuestionCategoryOrderByInput;
(function (QuestionCategoryOrderByInput) {
    QuestionCategoryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    QuestionCategoryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    QuestionCategoryOrderByInput["IdAsc"] = "id_ASC";
    QuestionCategoryOrderByInput["IdDesc"] = "id_DESC";
    QuestionCategoryOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    QuestionCategoryOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    QuestionCategoryOrderByInput["TitleAsc"] = "title_ASC";
    QuestionCategoryOrderByInput["TitleDesc"] = "title_DESC";
    QuestionCategoryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    QuestionCategoryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(QuestionCategoryOrderByInput || (QuestionCategoryOrderByInput = {}));
export var QuestionOrderByInput;
(function (QuestionOrderByInput) {
    QuestionOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    QuestionOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    QuestionOrderByInput["DescriptionAsc"] = "description_ASC";
    QuestionOrderByInput["DescriptionDesc"] = "description_DESC";
    QuestionOrderByInput["IdAsc"] = "id_ASC";
    QuestionOrderByInput["IdDesc"] = "id_DESC";
    QuestionOrderByInput["TitleAsc"] = "title_ASC";
    QuestionOrderByInput["TitleDesc"] = "title_DESC";
    QuestionOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    QuestionOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(QuestionOrderByInput || (QuestionOrderByInput = {}));
export var SurveyContentDependencyOrderByInput;
(function (SurveyContentDependencyOrderByInput) {
    SurveyContentDependencyOrderByInput["AnswerAsc"] = "answer_ASC";
    SurveyContentDependencyOrderByInput["AnswerDesc"] = "answer_DESC";
    SurveyContentDependencyOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveyContentDependencyOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveyContentDependencyOrderByInput["IdAsc"] = "id_ASC";
    SurveyContentDependencyOrderByInput["IdDesc"] = "id_DESC";
    SurveyContentDependencyOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveyContentDependencyOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(SurveyContentDependencyOrderByInput || (SurveyContentDependencyOrderByInput = {}));
export var SurveyContentOrderByInput;
(function (SurveyContentOrderByInput) {
    SurveyContentOrderByInput["ActiveAsc"] = "active_ASC";
    SurveyContentOrderByInput["ActiveDesc"] = "active_DESC";
    SurveyContentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveyContentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveyContentOrderByInput["DeletedAsc"] = "deleted_ASC";
    SurveyContentOrderByInput["DeletedDesc"] = "deleted_DESC";
    SurveyContentOrderByInput["DependencyOperatorAsc"] = "dependencyOperator_ASC";
    SurveyContentOrderByInput["DependencyOperatorDesc"] = "dependencyOperator_DESC";
    SurveyContentOrderByInput["IdAsc"] = "id_ASC";
    SurveyContentOrderByInput["IdDesc"] = "id_DESC";
    SurveyContentOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    SurveyContentOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    SurveyContentOrderByInput["PageBreakAsc"] = "pageBreak_ASC";
    SurveyContentOrderByInput["PageBreakDesc"] = "pageBreak_DESC";
    SurveyContentOrderByInput["PositionAsc"] = "position_ASC";
    SurveyContentOrderByInput["PositionDesc"] = "position_DESC";
    SurveyContentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveyContentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(SurveyContentOrderByInput || (SurveyContentOrderByInput = {}));
export var TextTranslationOrderByInput;
(function (TextTranslationOrderByInput) {
    TextTranslationOrderByInput["BodyAsc"] = "body_ASC";
    TextTranslationOrderByInput["BodyDesc"] = "body_DESC";
    TextTranslationOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    TextTranslationOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    TextTranslationOrderByInput["IdAsc"] = "id_ASC";
    TextTranslationOrderByInput["IdDesc"] = "id_DESC";
    TextTranslationOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    TextTranslationOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(TextTranslationOrderByInput || (TextTranslationOrderByInput = {}));
export var OptionOrderByInput;
(function (OptionOrderByInput) {
    OptionOrderByInput["ActiveAsc"] = "active_ASC";
    OptionOrderByInput["ActiveDesc"] = "active_DESC";
    OptionOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    OptionOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    OptionOrderByInput["IdAsc"] = "id_ASC";
    OptionOrderByInput["IdDesc"] = "id_DESC";
    OptionOrderByInput["LegacyIdAsc"] = "legacyId_ASC";
    OptionOrderByInput["LegacyIdDesc"] = "legacyId_DESC";
    OptionOrderByInput["PositionAsc"] = "position_ASC";
    OptionOrderByInput["PositionDesc"] = "position_DESC";
    OptionOrderByInput["TitleAsc"] = "title_ASC";
    OptionOrderByInput["TitleDesc"] = "title_DESC";
    OptionOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    OptionOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    OptionOrderByInput["ValueAsc"] = "value_ASC";
    OptionOrderByInput["ValueDesc"] = "value_DESC";
})(OptionOrderByInput || (OptionOrderByInput = {}));
export var OptionCategoryOrderByInput;
(function (OptionCategoryOrderByInput) {
    OptionCategoryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    OptionCategoryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    OptionCategoryOrderByInput["IdAsc"] = "id_ASC";
    OptionCategoryOrderByInput["IdDesc"] = "id_DESC";
    OptionCategoryOrderByInput["LegacyTitleAsc"] = "legacyTitle_ASC";
    OptionCategoryOrderByInput["LegacyTitleDesc"] = "legacyTitle_DESC";
    OptionCategoryOrderByInput["TitleAsc"] = "title_ASC";
    OptionCategoryOrderByInput["TitleDesc"] = "title_DESC";
    OptionCategoryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    OptionCategoryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(OptionCategoryOrderByInput || (OptionCategoryOrderByInput = {}));
export var TaggedCommentOrderByInput;
(function (TaggedCommentOrderByInput) {
    TaggedCommentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    TaggedCommentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    TaggedCommentOrderByInput["IdAsc"] = "id_ASC";
    TaggedCommentOrderByInput["IdDesc"] = "id_DESC";
    TaggedCommentOrderByInput["TextAsc"] = "text_ASC";
    TaggedCommentOrderByInput["TextDesc"] = "text_DESC";
    TaggedCommentOrderByInput["TypeAsc"] = "type_ASC";
    TaggedCommentOrderByInput["TypeDesc"] = "type_DESC";
    TaggedCommentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    TaggedCommentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(TaggedCommentOrderByInput || (TaggedCommentOrderByInput = {}));
export var TextResponseSummaryOrderByInput;
(function (TextResponseSummaryOrderByInput) {
    TextResponseSummaryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    TextResponseSummaryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    TextResponseSummaryOrderByInput["FingerprintAsc"] = "fingerprint_ASC";
    TextResponseSummaryOrderByInput["FingerprintDesc"] = "fingerprint_DESC";
    TextResponseSummaryOrderByInput["IdAsc"] = "id_ASC";
    TextResponseSummaryOrderByInput["IdDesc"] = "id_DESC";
    TextResponseSummaryOrderByInput["InputAsc"] = "input_ASC";
    TextResponseSummaryOrderByInput["InputDesc"] = "input_DESC";
    TextResponseSummaryOrderByInput["LanguageAsc"] = "language_ASC";
    TextResponseSummaryOrderByInput["LanguageDesc"] = "language_DESC";
    TextResponseSummaryOrderByInput["StatusAsc"] = "status_ASC";
    TextResponseSummaryOrderByInput["StatusDesc"] = "status_DESC";
    TextResponseSummaryOrderByInput["TextAsc"] = "text_ASC";
    TextResponseSummaryOrderByInput["TextDesc"] = "text_DESC";
    TextResponseSummaryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    TextResponseSummaryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(TextResponseSummaryOrderByInput || (TextResponseSummaryOrderByInput = {}));
export var FlaggedCommentMetaInputOrderByInput;
(function (FlaggedCommentMetaInputOrderByInput) {
    FlaggedCommentMetaInputOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FlaggedCommentMetaInputOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FlaggedCommentMetaInputOrderByInput["IdAsc"] = "id_ASC";
    FlaggedCommentMetaInputOrderByInput["IdDesc"] = "id_DESC";
    FlaggedCommentMetaInputOrderByInput["TypeAsc"] = "type_ASC";
    FlaggedCommentMetaInputOrderByInput["TypeDesc"] = "type_DESC";
    FlaggedCommentMetaInputOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FlaggedCommentMetaInputOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    FlaggedCommentMetaInputOrderByInput["ValueAsc"] = "value_ASC";
    FlaggedCommentMetaInputOrderByInput["ValueDesc"] = "value_DESC";
})(FlaggedCommentMetaInputOrderByInput || (FlaggedCommentMetaInputOrderByInput = {}));
export var FlaggedCommentOrderByInput;
(function (FlaggedCommentOrderByInput) {
    FlaggedCommentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FlaggedCommentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FlaggedCommentOrderByInput["IdAsc"] = "id_ASC";
    FlaggedCommentOrderByInput["IdDesc"] = "id_DESC";
    FlaggedCommentOrderByInput["LanguageAsc"] = "language_ASC";
    FlaggedCommentOrderByInput["LanguageDesc"] = "language_DESC";
    FlaggedCommentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FlaggedCommentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FlaggedCommentOrderByInput || (FlaggedCommentOrderByInput = {}));
export var ReportDistributionOrderByInput;
(function (ReportDistributionOrderByInput) {
    ReportDistributionOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ReportDistributionOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ReportDistributionOrderByInput["DeliveryMethodAsc"] = "deliveryMethod_ASC";
    ReportDistributionOrderByInput["DeliveryMethodDesc"] = "deliveryMethod_DESC";
    ReportDistributionOrderByInput["EndDateTimeAsc"] = "endDateTime_ASC";
    ReportDistributionOrderByInput["EndDateTimeDesc"] = "endDateTime_DESC";
    ReportDistributionOrderByInput["FrequencyAsc"] = "frequency_ASC";
    ReportDistributionOrderByInput["FrequencyDesc"] = "frequency_DESC";
    ReportDistributionOrderByInput["IdAsc"] = "id_ASC";
    ReportDistributionOrderByInput["IdDesc"] = "id_DESC";
    ReportDistributionOrderByInput["IncludePdfAsc"] = "includePDF_ASC";
    ReportDistributionOrderByInput["IncludePdfDesc"] = "includePDF_DESC";
    ReportDistributionOrderByInput["StartDateTimeAsc"] = "startDateTime_ASC";
    ReportDistributionOrderByInput["StartDateTimeDesc"] = "startDateTime_DESC";
    ReportDistributionOrderByInput["TextResponsesAsc"] = "textResponses_ASC";
    ReportDistributionOrderByInput["TextResponsesDesc"] = "textResponses_DESC";
    ReportDistributionOrderByInput["TitleAsc"] = "title_ASC";
    ReportDistributionOrderByInput["TitleDesc"] = "title_DESC";
    ReportDistributionOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ReportDistributionOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ReportDistributionOrderByInput || (ReportDistributionOrderByInput = {}));
export var ReportDeliveryOrderByInput;
(function (ReportDeliveryOrderByInput) {
    ReportDeliveryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ReportDeliveryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ReportDeliveryOrderByInput["DateAsc"] = "date_ASC";
    ReportDeliveryOrderByInput["DateDesc"] = "date_DESC";
    ReportDeliveryOrderByInput["IdAsc"] = "id_ASC";
    ReportDeliveryOrderByInput["IdDesc"] = "id_DESC";
    ReportDeliveryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ReportDeliveryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ReportDeliveryOrderByInput || (ReportDeliveryOrderByInput = {}));
export var ClientPanelOrderByInput;
(function (ClientPanelOrderByInput) {
    ClientPanelOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ClientPanelOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ClientPanelOrderByInput["EmailAsc"] = "email_ASC";
    ClientPanelOrderByInput["EmailDesc"] = "email_DESC";
    ClientPanelOrderByInput["IdAsc"] = "id_ASC";
    ClientPanelOrderByInput["IdDesc"] = "id_DESC";
    ClientPanelOrderByInput["NameAsc"] = "name_ASC";
    ClientPanelOrderByInput["NameDesc"] = "name_DESC";
    ClientPanelOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ClientPanelOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ClientPanelOrderByInput || (ClientPanelOrderByInput = {}));
export var DataSourceUsageOrderByInput;
(function (DataSourceUsageOrderByInput) {
    DataSourceUsageOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    DataSourceUsageOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    DataSourceUsageOrderByInput["CurrentAsc"] = "current_ASC";
    DataSourceUsageOrderByInput["CurrentDesc"] = "current_DESC";
    DataSourceUsageOrderByInput["EndDateAsc"] = "endDate_ASC";
    DataSourceUsageOrderByInput["EndDateDesc"] = "endDate_DESC";
    DataSourceUsageOrderByInput["EstimatedAsc"] = "estimated_ASC";
    DataSourceUsageOrderByInput["EstimatedDesc"] = "estimated_DESC";
    DataSourceUsageOrderByInput["IdAsc"] = "id_ASC";
    DataSourceUsageOrderByInput["IdDesc"] = "id_DESC";
    DataSourceUsageOrderByInput["LimitAsc"] = "limit_ASC";
    DataSourceUsageOrderByInput["LimitDesc"] = "limit_DESC";
    DataSourceUsageOrderByInput["PeriodAsc"] = "period_ASC";
    DataSourceUsageOrderByInput["PeriodDesc"] = "period_DESC";
    DataSourceUsageOrderByInput["SettingAsc"] = "setting_ASC";
    DataSourceUsageOrderByInput["SettingDesc"] = "setting_DESC";
    DataSourceUsageOrderByInput["StartDateAsc"] = "startDate_ASC";
    DataSourceUsageOrderByInput["StartDateDesc"] = "startDate_DESC";
    DataSourceUsageOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    DataSourceUsageOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(DataSourceUsageOrderByInput || (DataSourceUsageOrderByInput = {}));
export var FileOrderByInput;
(function (FileOrderByInput) {
    FileOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FileOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FileOrderByInput["FolderAsc"] = "folder_ASC";
    FileOrderByInput["FolderDesc"] = "folder_DESC";
    FileOrderByInput["FormatAsc"] = "format_ASC";
    FileOrderByInput["FormatDesc"] = "format_DESC";
    FileOrderByInput["HeightAsc"] = "height_ASC";
    FileOrderByInput["HeightDesc"] = "height_DESC";
    FileOrderByInput["IdAsc"] = "id_ASC";
    FileOrderByInput["IdDesc"] = "id_DESC";
    FileOrderByInput["LengthAsc"] = "length_ASC";
    FileOrderByInput["LengthDesc"] = "length_DESC";
    FileOrderByInput["S3KeyAsc"] = "s3Key_ASC";
    FileOrderByInput["S3KeyDesc"] = "s3Key_DESC";
    FileOrderByInput["SizeAsc"] = "size_ASC";
    FileOrderByInput["SizeDesc"] = "size_DESC";
    FileOrderByInput["TitleAsc"] = "title_ASC";
    FileOrderByInput["TitleDesc"] = "title_DESC";
    FileOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FileOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    FileOrderByInput["WidthAsc"] = "width_ASC";
    FileOrderByInput["WidthDesc"] = "width_DESC";
})(FileOrderByInput || (FileOrderByInput = {}));
export var CustomerPrivacyPolicyOrderByInput;
(function (CustomerPrivacyPolicyOrderByInput) {
    CustomerPrivacyPolicyOrderByInput["ContentAsc"] = "content_ASC";
    CustomerPrivacyPolicyOrderByInput["ContentDesc"] = "content_DESC";
    CustomerPrivacyPolicyOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CustomerPrivacyPolicyOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CustomerPrivacyPolicyOrderByInput["IdAsc"] = "id_ASC";
    CustomerPrivacyPolicyOrderByInput["IdDesc"] = "id_DESC";
    CustomerPrivacyPolicyOrderByInput["LanguageAsc"] = "language_ASC";
    CustomerPrivacyPolicyOrderByInput["LanguageDesc"] = "language_DESC";
    CustomerPrivacyPolicyOrderByInput["TypeAsc"] = "type_ASC";
    CustomerPrivacyPolicyOrderByInput["TypeDesc"] = "type_DESC";
    CustomerPrivacyPolicyOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CustomerPrivacyPolicyOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    CustomerPrivacyPolicyOrderByInput["UrlAsc"] = "url_ASC";
    CustomerPrivacyPolicyOrderByInput["UrlDesc"] = "url_DESC";
})(CustomerPrivacyPolicyOrderByInput || (CustomerPrivacyPolicyOrderByInput = {}));
export var ReportOrderByInput;
(function (ReportOrderByInput) {
    ReportOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ReportOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ReportOrderByInput["DescriptionAsc"] = "description_ASC";
    ReportOrderByInput["DescriptionDesc"] = "description_DESC";
    ReportOrderByInput["IdAsc"] = "id_ASC";
    ReportOrderByInput["IdDesc"] = "id_DESC";
    ReportOrderByInput["LanguageAsc"] = "language_ASC";
    ReportOrderByInput["LanguageDesc"] = "language_DESC";
    ReportOrderByInput["TimeOffsetAsc"] = "timeOffset_ASC";
    ReportOrderByInput["TimeOffsetDesc"] = "timeOffset_DESC";
    ReportOrderByInput["TitleAsc"] = "title_ASC";
    ReportOrderByInput["TitleDesc"] = "title_DESC";
    ReportOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ReportOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ReportOrderByInput || (ReportOrderByInput = {}));
export var SegmentOrderByInput;
(function (SegmentOrderByInput) {
    SegmentOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SegmentOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SegmentOrderByInput["IdAsc"] = "id_ASC";
    SegmentOrderByInput["IdDesc"] = "id_DESC";
    SegmentOrderByInput["QueryAsc"] = "query_ASC";
    SegmentOrderByInput["QueryDesc"] = "query_DESC";
    SegmentOrderByInput["TitleAsc"] = "title_ASC";
    SegmentOrderByInput["TitleDesc"] = "title_DESC";
    SegmentOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SegmentOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(SegmentOrderByInput || (SegmentOrderByInput = {}));
export var SettingOrderByInput;
(function (SettingOrderByInput) {
    SettingOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SettingOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SettingOrderByInput["IdAsc"] = "id_ASC";
    SettingOrderByInput["IdDesc"] = "id_DESC";
    SettingOrderByInput["KeyAsc"] = "key_ASC";
    SettingOrderByInput["KeyDesc"] = "key_DESC";
    SettingOrderByInput["RelationIdAsc"] = "relationId_ASC";
    SettingOrderByInput["RelationIdDesc"] = "relationId_DESC";
    SettingOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SettingOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    SettingOrderByInput["ValueAsc"] = "value_ASC";
    SettingOrderByInput["ValueDesc"] = "value_DESC";
})(SettingOrderByInput || (SettingOrderByInput = {}));
export var AccessibilityWebhookDeliveryOrderByInput;
(function (AccessibilityWebhookDeliveryOrderByInput) {
    AccessibilityWebhookDeliveryOrderByInput["ClassificationAsc"] = "classification_ASC";
    AccessibilityWebhookDeliveryOrderByInput["ClassificationDesc"] = "classification_DESC";
    AccessibilityWebhookDeliveryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AccessibilityWebhookDeliveryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AccessibilityWebhookDeliveryOrderByInput["DeliveryKeyAsc"] = "deliveryKey_ASC";
    AccessibilityWebhookDeliveryOrderByInput["DeliveryKeyDesc"] = "deliveryKey_DESC";
    AccessibilityWebhookDeliveryOrderByInput["IdAsc"] = "id_ASC";
    AccessibilityWebhookDeliveryOrderByInput["IdDesc"] = "id_DESC";
    AccessibilityWebhookDeliveryOrderByInput["PayloadAsc"] = "payload_ASC";
    AccessibilityWebhookDeliveryOrderByInput["PayloadDesc"] = "payload_DESC";
    AccessibilityWebhookDeliveryOrderByInput["ProviderAsc"] = "provider_ASC";
    AccessibilityWebhookDeliveryOrderByInput["ProviderDesc"] = "provider_DESC";
    AccessibilityWebhookDeliveryOrderByInput["ProviderSiteIdAsc"] = "providerSiteId_ASC";
    AccessibilityWebhookDeliveryOrderByInput["ProviderSiteIdDesc"] = "providerSiteId_DESC";
    AccessibilityWebhookDeliveryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AccessibilityWebhookDeliveryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(AccessibilityWebhookDeliveryOrderByInput || (AccessibilityWebhookDeliveryOrderByInput = {}));
export var AddressOrderByInput;
(function (AddressOrderByInput) {
    AddressOrderByInput["CityAsc"] = "city_ASC";
    AddressOrderByInput["CityDesc"] = "city_DESC";
    AddressOrderByInput["CountryCodeAsc"] = "countryCode_ASC";
    AddressOrderByInput["CountryCodeDesc"] = "countryCode_DESC";
    AddressOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    AddressOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    AddressOrderByInput["IdAsc"] = "id_ASC";
    AddressOrderByInput["IdDesc"] = "id_DESC";
    AddressOrderByInput["StreetAsc"] = "street_ASC";
    AddressOrderByInput["StreetDesc"] = "street_DESC";
    AddressOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    AddressOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    AddressOrderByInput["ZipAsc"] = "zip_ASC";
    AddressOrderByInput["ZipDesc"] = "zip_DESC";
})(AddressOrderByInput || (AddressOrderByInput = {}));
export var BlacklistWordOrderByInput;
(function (BlacklistWordOrderByInput) {
    BlacklistWordOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    BlacklistWordOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    BlacklistWordOrderByInput["IdAsc"] = "id_ASC";
    BlacklistWordOrderByInput["IdDesc"] = "id_DESC";
    BlacklistWordOrderByInput["LanguageAsc"] = "language_ASC";
    BlacklistWordOrderByInput["LanguageDesc"] = "language_DESC";
    BlacklistWordOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    BlacklistWordOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    BlacklistWordOrderByInput["WordAsc"] = "word_ASC";
    BlacklistWordOrderByInput["WordDesc"] = "word_DESC";
})(BlacklistWordOrderByInput || (BlacklistWordOrderByInput = {}));
export var BlockOrderByInput;
(function (BlockOrderByInput) {
    BlockOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    BlockOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    BlockOrderByInput["IdAsc"] = "id_ASC";
    BlockOrderByInput["IdDesc"] = "id_DESC";
    BlockOrderByInput["TitleAsc"] = "title_ASC";
    BlockOrderByInput["TitleDesc"] = "title_DESC";
    BlockOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    BlockOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(BlockOrderByInput || (BlockOrderByInput = {}));
export var ChartSettingsOrderByInput;
(function (ChartSettingsOrderByInput) {
    ChartSettingsOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ChartSettingsOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ChartSettingsOrderByInput["DisplayGradingScaleAsc"] = "displayGradingScale_ASC";
    ChartSettingsOrderByInput["DisplayGradingScaleDesc"] = "displayGradingScale_DESC";
    ChartSettingsOrderByInput["DisplayModeAsc"] = "displayMode_ASC";
    ChartSettingsOrderByInput["DisplayModeDesc"] = "displayMode_DESC";
    ChartSettingsOrderByInput["FieldResultTypeAsc"] = "fieldResultType_ASC";
    ChartSettingsOrderByInput["FieldResultTypeDesc"] = "fieldResultType_DESC";
    ChartSettingsOrderByInput["IdAsc"] = "id_ASC";
    ChartSettingsOrderByInput["IdDesc"] = "id_DESC";
    ChartSettingsOrderByInput["OrderAsc"] = "order_ASC";
    ChartSettingsOrderByInput["OrderDesc"] = "order_DESC";
    ChartSettingsOrderByInput["ShowDropOffAsc"] = "showDropOff_ASC";
    ChartSettingsOrderByInput["ShowDropOffDesc"] = "showDropOff_DESC";
    ChartSettingsOrderByInput["ShowLabelsAsc"] = "showLabels_ASC";
    ChartSettingsOrderByInput["ShowLabelsDesc"] = "showLabels_DESC";
    ChartSettingsOrderByInput["ShowPreviousStepAsc"] = "showPreviousStep_ASC";
    ChartSettingsOrderByInput["ShowPreviousStepDesc"] = "showPreviousStep_DESC";
    ChartSettingsOrderByInput["SwitchedAxisAsc"] = "switchedAxis_ASC";
    ChartSettingsOrderByInput["SwitchedAxisDesc"] = "switchedAxis_DESC";
    ChartSettingsOrderByInput["TypeAsc"] = "type_ASC";
    ChartSettingsOrderByInput["TypeDesc"] = "type_DESC";
    ChartSettingsOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ChartSettingsOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    ChartSettingsOrderByInput["XAxisMarkerAsc"] = "xAxisMarker_ASC";
    ChartSettingsOrderByInput["XAxisMarkerDesc"] = "xAxisMarker_DESC";
    ChartSettingsOrderByInput["YAxisMarkerAsc"] = "yAxisMarker_ASC";
    ChartSettingsOrderByInput["YAxisMarkerDesc"] = "yAxisMarker_DESC";
})(ChartSettingsOrderByInput || (ChartSettingsOrderByInput = {}));
export var ContentSettingsOrderByInput;
(function (ContentSettingsOrderByInput) {
    ContentSettingsOrderByInput["ChartCommentAsc"] = "chartComment_ASC";
    ContentSettingsOrderByInput["ChartCommentDesc"] = "chartComment_DESC";
    ContentSettingsOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ContentSettingsOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ContentSettingsOrderByInput["IdAsc"] = "id_ASC";
    ContentSettingsOrderByInput["IdDesc"] = "id_DESC";
    ContentSettingsOrderByInput["QuestionCategoryAsc"] = "questionCategory_ASC";
    ContentSettingsOrderByInput["QuestionCategoryDesc"] = "questionCategory_DESC";
    ContentSettingsOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ContentSettingsOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ContentSettingsOrderByInput || (ContentSettingsOrderByInput = {}));
export var CountryOrderByInput;
(function (CountryOrderByInput) {
    CountryOrderByInput["CodeAsc"] = "code_ASC";
    CountryOrderByInput["CodeDesc"] = "code_DESC";
    CountryOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CountryOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CountryOrderByInput["IdAsc"] = "id_ASC";
    CountryOrderByInput["IdDesc"] = "id_DESC";
    CountryOrderByInput["NameAsc"] = "name_ASC";
    CountryOrderByInput["NameDesc"] = "name_DESC";
    CountryOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CountryOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(CountryOrderByInput || (CountryOrderByInput = {}));
export var RegionOrderByInput;
(function (RegionOrderByInput) {
    RegionOrderByInput["CodeAsc"] = "code_ASC";
    RegionOrderByInput["CodeDesc"] = "code_DESC";
    RegionOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    RegionOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    RegionOrderByInput["IdAsc"] = "id_ASC";
    RegionOrderByInput["IdDesc"] = "id_DESC";
    RegionOrderByInput["TitleAsc"] = "title_ASC";
    RegionOrderByInput["TitleDesc"] = "title_DESC";
    RegionOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    RegionOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(RegionOrderByInput || (RegionOrderByInput = {}));
export var MunicipalityOrderByInput;
(function (MunicipalityOrderByInput) {
    MunicipalityOrderByInput["CodeAsc"] = "code_ASC";
    MunicipalityOrderByInput["CodeDesc"] = "code_DESC";
    MunicipalityOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    MunicipalityOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    MunicipalityOrderByInput["IdAsc"] = "id_ASC";
    MunicipalityOrderByInput["IdDesc"] = "id_DESC";
    MunicipalityOrderByInput["TitleAsc"] = "title_ASC";
    MunicipalityOrderByInput["TitleDesc"] = "title_DESC";
    MunicipalityOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    MunicipalityOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(MunicipalityOrderByInput || (MunicipalityOrderByInput = {}));
export var ZipOrderByInput;
(function (ZipOrderByInput) {
    ZipOrderByInput["CodeAsc"] = "code_ASC";
    ZipOrderByInput["CodeDesc"] = "code_DESC";
    ZipOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ZipOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ZipOrderByInput["IdAsc"] = "id_ASC";
    ZipOrderByInput["IdDesc"] = "id_DESC";
    ZipOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ZipOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ZipOrderByInput || (ZipOrderByInput = {}));
export var CouponOrderByInput;
(function (CouponOrderByInput) {
    CouponOrderByInput["CodeAsc"] = "code_ASC";
    CouponOrderByInput["CodeDesc"] = "code_DESC";
    CouponOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CouponOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CouponOrderByInput["DescriptionAsc"] = "description_ASC";
    CouponOrderByInput["DescriptionDesc"] = "description_DESC";
    CouponOrderByInput["DiscountAmountAsc"] = "discountAmount_ASC";
    CouponOrderByInput["DiscountAmountDesc"] = "discountAmount_DESC";
    CouponOrderByInput["DiscountTypeAsc"] = "discountType_ASC";
    CouponOrderByInput["DiscountTypeDesc"] = "discountType_DESC";
    CouponOrderByInput["ExpirationDateAsc"] = "expirationDate_ASC";
    CouponOrderByInput["ExpirationDateDesc"] = "expirationDate_DESC";
    CouponOrderByInput["IdAsc"] = "id_ASC";
    CouponOrderByInput["IdDesc"] = "id_DESC";
    CouponOrderByInput["LimitPerCustomerAsc"] = "limitPerCustomer_ASC";
    CouponOrderByInput["LimitPerCustomerDesc"] = "limitPerCustomer_DESC";
    CouponOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CouponOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(CouponOrderByInput || (CouponOrderByInput = {}));
export var CustomThemeOrderByInput;
(function (CustomThemeOrderByInput) {
    CustomThemeOrderByInput["AcceptButtonColorAsc"] = "acceptButtonColor_ASC";
    CustomThemeOrderByInput["AcceptButtonColorDesc"] = "acceptButtonColor_DESC";
    CustomThemeOrderByInput["AcceptButtonTextColorAsc"] = "acceptButtonTextColor_ASC";
    CustomThemeOrderByInput["AcceptButtonTextColorDesc"] = "acceptButtonTextColor_DESC";
    CustomThemeOrderByInput["BorderColorAsc"] = "borderColor_ASC";
    CustomThemeOrderByInput["BorderColorDesc"] = "borderColor_DESC";
    CustomThemeOrderByInput["ButtonColorAsc"] = "buttonColor_ASC";
    CustomThemeOrderByInput["ButtonColorDesc"] = "buttonColor_DESC";
    CustomThemeOrderByInput["ButtonTextColorAsc"] = "buttonTextColor_ASC";
    CustomThemeOrderByInput["ButtonTextColorDesc"] = "buttonTextColor_DESC";
    CustomThemeOrderByInput["CornerRadiusAsc"] = "cornerRadius_ASC";
    CustomThemeOrderByInput["CornerRadiusDesc"] = "cornerRadius_DESC";
    CustomThemeOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CustomThemeOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CustomThemeOrderByInput["CustomCssAsc"] = "customCSS_ASC";
    CustomThemeOrderByInput["CustomCssDesc"] = "customCSS_DESC";
    CustomThemeOrderByInput["DeclineButtonColorAsc"] = "declineButtonColor_ASC";
    CustomThemeOrderByInput["DeclineButtonColorDesc"] = "declineButtonColor_DESC";
    CustomThemeOrderByInput["DeclineButtonTextColorAsc"] = "declineButtonTextColor_ASC";
    CustomThemeOrderByInput["DeclineButtonTextColorDesc"] = "declineButtonTextColor_DESC";
    CustomThemeOrderByInput["DescriptionColorAsc"] = "descriptionColor_ASC";
    CustomThemeOrderByInput["DescriptionColorDesc"] = "descriptionColor_DESC";
    CustomThemeOrderByInput["DisclaimerColorAsc"] = "disclaimerColor_ASC";
    CustomThemeOrderByInput["DisclaimerColorDesc"] = "disclaimerColor_DESC";
    CustomThemeOrderByInput["HeaderColorAsc"] = "headerColor_ASC";
    CustomThemeOrderByInput["HeaderColorDesc"] = "headerColor_DESC";
    CustomThemeOrderByInput["IdAsc"] = "id_ASC";
    CustomThemeOrderByInput["IdDesc"] = "id_DESC";
    CustomThemeOrderByInput["InputBackgroundColorAsc"] = "inputBackgroundColor_ASC";
    CustomThemeOrderByInput["InputBackgroundColorDesc"] = "inputBackgroundColor_DESC";
    CustomThemeOrderByInput["InputBorderColorAsc"] = "inputBorderColor_ASC";
    CustomThemeOrderByInput["InputBorderColorDesc"] = "inputBorderColor_DESC";
    CustomThemeOrderByInput["InputErrorColorAsc"] = "inputErrorColor_ASC";
    CustomThemeOrderByInput["InputErrorColorDesc"] = "inputErrorColor_DESC";
    CustomThemeOrderByInput["InputFocusColorAsc"] = "inputFocusColor_ASC";
    CustomThemeOrderByInput["InputFocusColorDesc"] = "inputFocusColor_DESC";
    CustomThemeOrderByInput["InputSelectedBackgroundColorAsc"] = "inputSelectedBackgroundColor_ASC";
    CustomThemeOrderByInput["InputSelectedBackgroundColorDesc"] = "inputSelectedBackgroundColor_DESC";
    CustomThemeOrderByInput["InputSelectedBorderColorAsc"] = "inputSelectedBorderColor_ASC";
    CustomThemeOrderByInput["InputSelectedBorderColorDesc"] = "inputSelectedBorderColor_DESC";
    CustomThemeOrderByInput["InputSelectedTextColorAsc"] = "inputSelectedTextColor_ASC";
    CustomThemeOrderByInput["InputSelectedTextColorDesc"] = "inputSelectedTextColor_DESC";
    CustomThemeOrderByInput["InputTextColorAsc"] = "inputTextColor_ASC";
    CustomThemeOrderByInput["InputTextColorDesc"] = "inputTextColor_DESC";
    CustomThemeOrderByInput["LinkColorAsc"] = "linkColor_ASC";
    CustomThemeOrderByInput["LinkColorDesc"] = "linkColor_DESC";
    CustomThemeOrderByInput["PageBackgroundColorAsc"] = "pageBackgroundColor_ASC";
    CustomThemeOrderByInput["PageBackgroundColorDesc"] = "pageBackgroundColor_DESC";
    CustomThemeOrderByInput["PrimaryColorAsc"] = "primaryColor_ASC";
    CustomThemeOrderByInput["PrimaryColorDesc"] = "primaryColor_DESC";
    CustomThemeOrderByInput["ProgressBarBackgroundColorAsc"] = "progressBarBackgroundColor_ASC";
    CustomThemeOrderByInput["ProgressBarBackgroundColorDesc"] = "progressBarBackgroundColor_DESC";
    CustomThemeOrderByInput["ProgressBarColorAsc"] = "progressBarColor_ASC";
    CustomThemeOrderByInput["ProgressBarColorDesc"] = "progressBarColor_DESC";
    CustomThemeOrderByInput["QuestionColorAsc"] = "questionColor_ASC";
    CustomThemeOrderByInput["QuestionColorDesc"] = "questionColor_DESC";
    CustomThemeOrderByInput["SecondaryColorAsc"] = "secondaryColor_ASC";
    CustomThemeOrderByInput["SecondaryColorDesc"] = "secondaryColor_DESC";
    CustomThemeOrderByInput["SurveyBackgroundColorAsc"] = "surveyBackgroundColor_ASC";
    CustomThemeOrderByInput["SurveyBackgroundColorDesc"] = "surveyBackgroundColor_DESC";
    CustomThemeOrderByInput["TextColorAsc"] = "textColor_ASC";
    CustomThemeOrderByInput["TextColorDesc"] = "textColor_DESC";
    CustomThemeOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CustomThemeOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(CustomThemeOrderByInput || (CustomThemeOrderByInput = {}));
export var CxOrderByInput;
(function (CxOrderByInput) {
    CxOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CxOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CxOrderByInput["IdAsc"] = "id_ASC";
    CxOrderByInput["IdDesc"] = "id_DESC";
    CxOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CxOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(CxOrderByInput || (CxOrderByInput = {}));
export var FilterDateRangeOrderByInput;
(function (FilterDateRangeOrderByInput) {
    FilterDateRangeOrderByInput["ComparePeriodAsc"] = "comparePeriod_ASC";
    FilterDateRangeOrderByInput["ComparePeriodDesc"] = "comparePeriod_DESC";
    FilterDateRangeOrderByInput["CompareToPreviousAsc"] = "compareToPrevious_ASC";
    FilterDateRangeOrderByInput["CompareToPreviousDesc"] = "compareToPrevious_DESC";
    FilterDateRangeOrderByInput["CompareToPreviousValueAsc"] = "compareToPreviousValue_ASC";
    FilterDateRangeOrderByInput["CompareToPreviousValueDesc"] = "compareToPreviousValue_DESC";
    FilterDateRangeOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FilterDateRangeOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FilterDateRangeOrderByInput["IdAsc"] = "id_ASC";
    FilterDateRangeOrderByInput["IdDesc"] = "id_DESC";
    FilterDateRangeOrderByInput["LastNumberInputAsc"] = "lastNumberInput_ASC";
    FilterDateRangeOrderByInput["LastNumberInputDesc"] = "lastNumberInput_DESC";
    FilterDateRangeOrderByInput["PeriodAsc"] = "period_ASC";
    FilterDateRangeOrderByInput["PeriodDesc"] = "period_DESC";
    FilterDateRangeOrderByInput["PeriodTypeAsc"] = "periodType_ASC";
    FilterDateRangeOrderByInput["PeriodTypeDesc"] = "periodType_DESC";
    FilterDateRangeOrderByInput["SpecificDatesAsc"] = "specificDates_ASC";
    FilterDateRangeOrderByInput["SpecificDatesDesc"] = "specificDates_DESC";
    FilterDateRangeOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FilterDateRangeOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FilterDateRangeOrderByInput || (FilterDateRangeOrderByInput = {}));
export var FunnelOrderByInput;
(function (FunnelOrderByInput) {
    FunnelOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    FunnelOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    FunnelOrderByInput["IdAsc"] = "id_ASC";
    FunnelOrderByInput["IdDesc"] = "id_DESC";
    FunnelOrderByInput["TitleAsc"] = "title_ASC";
    FunnelOrderByInput["TitleDesc"] = "title_DESC";
    FunnelOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    FunnelOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(FunnelOrderByInput || (FunnelOrderByInput = {}));
export var ImageOrderByInput;
(function (ImageOrderByInput) {
    ImageOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ImageOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ImageOrderByInput["FormatAsc"] = "format_ASC";
    ImageOrderByInput["FormatDesc"] = "format_DESC";
    ImageOrderByInput["HeightAsc"] = "height_ASC";
    ImageOrderByInput["HeightDesc"] = "height_DESC";
    ImageOrderByInput["IdAsc"] = "id_ASC";
    ImageOrderByInput["IdDesc"] = "id_DESC";
    ImageOrderByInput["SizeAsc"] = "size_ASC";
    ImageOrderByInput["SizeDesc"] = "size_DESC";
    ImageOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ImageOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    ImageOrderByInput["UrlAsc"] = "url_ASC";
    ImageOrderByInput["UrlDesc"] = "url_DESC";
    ImageOrderByInput["WidthAsc"] = "width_ASC";
    ImageOrderByInput["WidthDesc"] = "width_DESC";
})(ImageOrderByInput || (ImageOrderByInput = {}));
export var LicenseOrderByInput;
(function (LicenseOrderByInput) {
    LicenseOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    LicenseOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    LicenseOrderByInput["IdAsc"] = "id_ASC";
    LicenseOrderByInput["IdDesc"] = "id_DESC";
    LicenseOrderByInput["LevelAsc"] = "level_ASC";
    LicenseOrderByInput["LevelDesc"] = "level_DESC";
    LicenseOrderByInput["StatusAsc"] = "status_ASC";
    LicenseOrderByInput["StatusDesc"] = "status_DESC";
    LicenseOrderByInput["TitleAsc"] = "title_ASC";
    LicenseOrderByInput["TitleDesc"] = "title_DESC";
    LicenseOrderByInput["UniqueTitleAsc"] = "uniqueTitle_ASC";
    LicenseOrderByInput["UniqueTitleDesc"] = "uniqueTitle_DESC";
    LicenseOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    LicenseOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(LicenseOrderByInput || (LicenseOrderByInput = {}));
export var OptionGroupOrderByInput;
(function (OptionGroupOrderByInput) {
    OptionGroupOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    OptionGroupOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    OptionGroupOrderByInput["IdAsc"] = "id_ASC";
    OptionGroupOrderByInput["IdDesc"] = "id_DESC";
    OptionGroupOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    OptionGroupOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(OptionGroupOrderByInput || (OptionGroupOrderByInput = {}));
export var QuestionGroupOrderByInput;
(function (QuestionGroupOrderByInput) {
    QuestionGroupOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    QuestionGroupOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    QuestionGroupOrderByInput["IdAsc"] = "id_ASC";
    QuestionGroupOrderByInput["IdDesc"] = "id_DESC";
    QuestionGroupOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    QuestionGroupOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(QuestionGroupOrderByInput || (QuestionGroupOrderByInput = {}));
export var QuestionResponsePiiScanOrderByInput;
(function (QuestionResponsePiiScanOrderByInput) {
    QuestionResponsePiiScanOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    QuestionResponsePiiScanOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    QuestionResponsePiiScanOrderByInput["DetectedAsc"] = "detected_ASC";
    QuestionResponsePiiScanOrderByInput["DetectedDesc"] = "detected_DESC";
    QuestionResponsePiiScanOrderByInput["IdAsc"] = "id_ASC";
    QuestionResponsePiiScanOrderByInput["IdDesc"] = "id_DESC";
    QuestionResponsePiiScanOrderByInput["ModelAsc"] = "model_ASC";
    QuestionResponsePiiScanOrderByInput["ModelDesc"] = "model_DESC";
    QuestionResponsePiiScanOrderByInput["ResultAsc"] = "result_ASC";
    QuestionResponsePiiScanOrderByInput["ResultDesc"] = "result_DESC";
    QuestionResponsePiiScanOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    QuestionResponsePiiScanOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(QuestionResponsePiiScanOrderByInput || (QuestionResponsePiiScanOrderByInput = {}));
export var QuestionSettingsOrderByInput;
(function (QuestionSettingsOrderByInput) {
    QuestionSettingsOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    QuestionSettingsOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    QuestionSettingsOrderByInput["EmailAsc"] = "email_ASC";
    QuestionSettingsOrderByInput["EmailDesc"] = "email_DESC";
    QuestionSettingsOrderByInput["IdAsc"] = "id_ASC";
    QuestionSettingsOrderByInput["IdDesc"] = "id_DESC";
    QuestionSettingsOrderByInput["LockLastOptionAsc"] = "lockLastOption_ASC";
    QuestionSettingsOrderByInput["LockLastOptionDesc"] = "lockLastOption_DESC";
    QuestionSettingsOrderByInput["MaxAsc"] = "max_ASC";
    QuestionSettingsOrderByInput["MaxDesc"] = "max_DESC";
    QuestionSettingsOrderByInput["MinAsc"] = "min_ASC";
    QuestionSettingsOrderByInput["MinDesc"] = "min_DESC";
    QuestionSettingsOrderByInput["RandomAsc"] = "random_ASC";
    QuestionSettingsOrderByInput["RandomDesc"] = "random_DESC";
    QuestionSettingsOrderByInput["RequiredAsc"] = "required_ASC";
    QuestionSettingsOrderByInput["RequiredDesc"] = "required_DESC";
    QuestionSettingsOrderByInput["RowsAsc"] = "rows_ASC";
    QuestionSettingsOrderByInput["RowsDesc"] = "rows_DESC";
    QuestionSettingsOrderByInput["SubTypeAsc"] = "subType_ASC";
    QuestionSettingsOrderByInput["SubTypeDesc"] = "subType_DESC";
    QuestionSettingsOrderByInput["TypeAsc"] = "type_ASC";
    QuestionSettingsOrderByInput["TypeDesc"] = "type_DESC";
    QuestionSettingsOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    QuestionSettingsOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(QuestionSettingsOrderByInput || (QuestionSettingsOrderByInput = {}));
export var ResultsConfigOrderByInput;
(function (ResultsConfigOrderByInput) {
    ResultsConfigOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ResultsConfigOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ResultsConfigOrderByInput["FilterAsc"] = "filter_ASC";
    ResultsConfigOrderByInput["FilterDesc"] = "filter_DESC";
    ResultsConfigOrderByInput["IdAsc"] = "id_ASC";
    ResultsConfigOrderByInput["IdDesc"] = "id_DESC";
    ResultsConfigOrderByInput["SettingsAsc"] = "settings_ASC";
    ResultsConfigOrderByInput["SettingsDesc"] = "settings_DESC";
    ResultsConfigOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ResultsConfigOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ResultsConfigOrderByInput || (ResultsConfigOrderByInput = {}));
export var ScoreResultsSettingsOrderByInput;
(function (ScoreResultsSettingsOrderByInput) {
    ScoreResultsSettingsOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    ScoreResultsSettingsOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    ScoreResultsSettingsOrderByInput["IdAsc"] = "id_ASC";
    ScoreResultsSettingsOrderByInput["IdDesc"] = "id_DESC";
    ScoreResultsSettingsOrderByInput["TitleAsc"] = "title_ASC";
    ScoreResultsSettingsOrderByInput["TitleDesc"] = "title_DESC";
    ScoreResultsSettingsOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    ScoreResultsSettingsOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(ScoreResultsSettingsOrderByInput || (ScoreResultsSettingsOrderByInput = {}));
export var SurveySettingsOrderByInput;
(function (SurveySettingsOrderByInput) {
    SurveySettingsOrderByInput["ClientPanelAsc"] = "clientPanel_ASC";
    SurveySettingsOrderByInput["ClientPanelDesc"] = "clientPanel_DESC";
    SurveySettingsOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    SurveySettingsOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    SurveySettingsOrderByInput["HideIntroDisclaimerAsc"] = "hideIntroDisclaimer_ASC";
    SurveySettingsOrderByInput["HideIntroDisclaimerDesc"] = "hideIntroDisclaimer_DESC";
    SurveySettingsOrderByInput["IdAsc"] = "id_ASC";
    SurveySettingsOrderByInput["IdDesc"] = "id_DESC";
    SurveySettingsOrderByInput["ShowProgressAsc"] = "showProgress_ASC";
    SurveySettingsOrderByInput["ShowProgressDesc"] = "showProgress_DESC";
    SurveySettingsOrderByInput["ShowWelcomePageAsc"] = "showWelcomePage_ASC";
    SurveySettingsOrderByInput["ShowWelcomePageDesc"] = "showWelcomePage_DESC";
    SurveySettingsOrderByInput["ThankYouPageContentAsc"] = "thankYouPageContent_ASC";
    SurveySettingsOrderByInput["ThankYouPageContentDesc"] = "thankYouPageContent_DESC";
    SurveySettingsOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    SurveySettingsOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    SurveySettingsOrderByInput["WelcomePageContentAsc"] = "welcomePageContent_ASC";
    SurveySettingsOrderByInput["WelcomePageContentDesc"] = "welcomePageContent_DESC";
})(SurveySettingsOrderByInput || (SurveySettingsOrderByInput = {}));
export var TextOrderByInput;
(function (TextOrderByInput) {
    TextOrderByInput["BodyAsc"] = "body_ASC";
    TextOrderByInput["BodyDesc"] = "body_DESC";
    TextOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    TextOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    TextOrderByInput["IdAsc"] = "id_ASC";
    TextOrderByInput["IdDesc"] = "id_DESC";
    TextOrderByInput["TitleAsc"] = "title_ASC";
    TextOrderByInput["TitleDesc"] = "title_DESC";
    TextOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    TextOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(TextOrderByInput || (TextOrderByInput = {}));
export var TranslationOrderByInput;
(function (TranslationOrderByInput) {
    TranslationOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    TranslationOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    TranslationOrderByInput["IdAsc"] = "id_ASC";
    TranslationOrderByInput["IdDesc"] = "id_DESC";
    TranslationOrderByInput["KeyAsc"] = "key_ASC";
    TranslationOrderByInput["KeyDesc"] = "key_DESC";
    TranslationOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    TranslationOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    TranslationOrderByInput["ValueAsc"] = "value_ASC";
    TranslationOrderByInput["ValueDesc"] = "value_DESC";
})(TranslationOrderByInput || (TranslationOrderByInput = {}));
export var UserOrderByInput;
(function (UserOrderByInput) {
    UserOrderByInput["Auth0IdAsc"] = "auth0Id_ASC";
    UserOrderByInput["Auth0IdDesc"] = "auth0Id_DESC";
    UserOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    UserOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    UserOrderByInput["DefaultMfaAsc"] = "defaultMfa_ASC";
    UserOrderByInput["DefaultMfaDesc"] = "defaultMfa_DESC";
    UserOrderByInput["EmailAsc"] = "email_ASC";
    UserOrderByInput["EmailDesc"] = "email_DESC";
    UserOrderByInput["FirstnameAsc"] = "firstname_ASC";
    UserOrderByInput["FirstnameDesc"] = "firstname_DESC";
    UserOrderByInput["IdAsc"] = "id_ASC";
    UserOrderByInput["IdDesc"] = "id_DESC";
    UserOrderByInput["LastLoginAsc"] = "lastLogin_ASC";
    UserOrderByInput["LastLoginDesc"] = "lastLogin_DESC";
    UserOrderByInput["LastnameAsc"] = "lastname_ASC";
    UserOrderByInput["LastnameDesc"] = "lastname_DESC";
    UserOrderByInput["LoginsCountAsc"] = "loginsCount_ASC";
    UserOrderByInput["LoginsCountDesc"] = "loginsCount_DESC";
    UserOrderByInput["MfaAsc"] = "mfa_ASC";
    UserOrderByInput["MfaDesc"] = "mfa_DESC";
    UserOrderByInput["PhoneAsc"] = "phone_ASC";
    UserOrderByInput["PhoneDesc"] = "phone_DESC";
    UserOrderByInput["ResetPasswordRequestAsc"] = "resetPasswordRequest_ASC";
    UserOrderByInput["ResetPasswordRequestDesc"] = "resetPasswordRequest_DESC";
    UserOrderByInput["StatusAsc"] = "status_ASC";
    UserOrderByInput["StatusDesc"] = "status_DESC";
    UserOrderByInput["TotpSecretAsc"] = "totpSecret_ASC";
    UserOrderByInput["TotpSecretDesc"] = "totpSecret_DESC";
    UserOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    UserOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(UserOrderByInput || (UserOrderByInput = {}));
export var WhitelistWordOrderByInput;
(function (WhitelistWordOrderByInput) {
    WhitelistWordOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    WhitelistWordOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    WhitelistWordOrderByInput["IdAsc"] = "id_ASC";
    WhitelistWordOrderByInput["IdDesc"] = "id_DESC";
    WhitelistWordOrderByInput["LanguageAsc"] = "language_ASC";
    WhitelistWordOrderByInput["LanguageDesc"] = "language_DESC";
    WhitelistWordOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    WhitelistWordOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    WhitelistWordOrderByInput["WordAsc"] = "word_ASC";
    WhitelistWordOrderByInput["WordDesc"] = "word_DESC";
})(WhitelistWordOrderByInput || (WhitelistWordOrderByInput = {}));
export var MutationType;
(function (MutationType) {
    MutationType["Created"] = "CREATED";
    MutationType["Deleted"] = "DELETED";
    MutationType["Updated"] = "UPDATED";
})(MutationType || (MutationType = {}));
